/*
 * Copyright © 2018-2024, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export const mainStringsHu = {
  noUnreadNotifications: "Nincs olvasatlan értesítés.",
  setupProfilePreferencesPhoneTitle: "Beállítások",
  setupProfilePhonePhoneTitle: "Telefon",
  setupProfileAddressPhoneTitle: "Lakcím",
  setupProfileRolePhoneTitle: "Felhasználói szerep",
  cookieConsentText: "Ez az oldal sütiket használ a jobb felhasználói élményért.",
  acceptCookie: "Elfogadom a sütiket",
  declineCookie: "Elutasítom",
  pleaseSetupYourProfile: "Kérjük, egészítsd ki a regisztrációd.",
  wrongEmailOrPassword: "Helytelen email vagy jelszó!",
  title: "Cím",
  addNewExternalMedicalRecord: "Új jegyzet",
  medicalRecords: "Kórlapok",
  couldNotRetrieveMedicalRecords: "Kórlapok lekérése sikertelen",
  externalMedicalRecords: "Jegyzetek",
  externalMedicalRecord: "Jegyzet",
  couldNotRetrieveExternalMedicalRecords: "Jegyzetek lekérése sikertelen",
  maintenanceModeMessage: "Az oldal karbantartás alatt, Kérjük, látogasson vissza később!",
  maintenanceModeEnabled: "Karbantartás mód",
  maintenanceSettings: "Karbantartás",
  vetDocumentsWereRejected: "A documentumokat elutasították.",
  vetDocumentSubmitted: "Az állatorvosi regisztrációs igazolás feltöltésre került, és jóváhagyásra vár.",
  ePrescriptions: "eReceptek",
  couldNotRetrievePrescriptions: "Receptek lekérése sikertelen",
  submitDocument: "Dokumentum elküldése",
  addFile: "Fájl hozzáadása",
  farmAnimals: "Haszonállatok",
  createEmergencyAppointment: "Sürgősségi foglalás létrehozása",
  emergencyAppointment: "Sürgősségi foglalás",
  serviceEnabledForCountry: "Szolgáltatás elérhető",
  allowReservationFor: "Foglalható az alábbi munkakörökhöz",
  startOfAppointment: "Foglalás kezdete",
  endOfAppointment: "Foglalás vége",
  chooseAnEmploymentType: "Válassz legalább egy munkakört.",
  employmentType: "Munkakör",
  deceased: "Elhunyt",
  insuranceNumber: "Biztosítási szám",
  passportNumber: "Útlevélszám",
  alternativeMobilePhone: "Alternatív telefonszám",
  sendNewRegistrationConfirmationMail: "Új megerősítő email küldése",
  youCannotLoginBecauseEmailIsNotVerifiedYet: "Az Ön e-mail címe még nincs megerősítve.",
  fillPetDataBeforeMedicalRecordMsg: "A kórlap megnyitása előtt kérem töltse ki a szükséges adatokat.",
  proceedToMedicalRecord: "Tovább a kórlapra",
  emailNotConfirmed: "Email cím nincs megerősítve",
  emailConfirmationResendText: "Email cím megerősítéséhez kérhetsz új emailt.",
  resendConfirmationEmailBtnTxt: "Aktiváló link újraküldése",

  phoneNotConfirmed: "Telefonszám nincs megerősítve",
  phoneConfirmationResendText: "Telefonszám megerősítésére kérhet új SMS-t.",
  resendConfirmationSmsBtnTxt: "SMS küldése",

  organizationNameIsIncorrect: "Helytelen szervezetnév.",
  organizationOwnersPassword: "Tulajdonos jelszava",
  organizationDeleteConfirmation: "Biztos ki szeretnéd törölni ezt a szervezetet?",
  organizationDeleted: "A szervezet sikeresen törölve lett.",
  deleteInProgress: "Törlés...",
  organizationName: "Vállalkozás neve",
  clinicDeletionWarning:
    "Figyelem! Minden rendelőhöz kapcsolódó, eltárolt adat végleges törlésre kerül és a törlés nem vonható vissza.",
  organizationDeletionWarning:
    "Figyelem! Minden szervezethez kapcsolódó, eltárolt adat végleges törlésre kerül és a törlés nem vonható vissza.",
  clinicOwnersPassword: "Owner's password",
  clinicCreated: "A rendelőt sikeresen létrehoztad.",
  clinicDeleted: "A rendelőt sikeresen törölted.",
  clinicDeletionConfirmationEmailSent: "Küldtünk egy emailt, melynek segítségével megerősítheted a rendelő törlését.",
  clinicName: "Rendelő neve",
  other: "Egyéb",
  deleteClinic: "Rendelő törlése",
  deleteOrganization: "Szervezet törlése",
  approveVets: "Orvosok megerősítése",
  userId: "Felhasználói azonosító",
  fileOrFiles: "Fájl(ok)",
  noFile: "Nincs fájl",
  viewFiles: "{0} fájl megtekintése",
  actions: "Műveletek",
  medicalCertificate: "Állatorvosi bizonyítvány",
  submitMedicinalCertificate: "Állatorvosi bizonyítvány feltöltése",
  vetProfessionNotValidated:
    "Receptek feltöltéséhez bizonyítania kell, hogy álllatorvosként dolgozik. Kérjük töltse fel az állatorvosi végzettségét igazoló dokumentumot.",
  vetProfessionDocumentsRejected: "A feltöltött dokumentumo(ka)t elutasították.",
  approve: "Elfogad",
  approveVetProfessionConfirmation: "Állatorvosi végzettség igazolásának megerősítése",
  approveVetProfessionConfirmationMessage:
    "Biztosan jóváhagyja az állatorvosi végzettséget igazoló dokumentumokat ehhez az állatorvoshoz?",
  documents: "Dokumentumok",
  document: "Dokumentum",
  rejectVetProfessionConfirmation: "Állatorvosi végzettség igazolásának elutasítása",
  rejectVetProfessionConfirmationMessage:
    "Biztosan elutasítja az állatorvosi végzettséget igazoló dokumentumokat ehhez az állatorvoshoz?",
  message: "Üzenet",
  rejectionMessagePlaceholder: "Írja le az elutasítás okait...",

  // emailTpyes
  PRIVATE: "Privát",
  PRIMARY: "Elsődleges",

  // Days
  Mon: "H",
  Tue: "K",
  Wed: "Sze",
  Thu: "Cs",
  Fri: "P",
  Sat: "Szo",
  Sun: "V",

  MONDAY: "Hétfő",
  TUESDAY: "Kedd",
  WEDNESDAY: "Szerda",
  THURSDAY: "Csütörtök",
  FRIDAY: "Péntek",
  SATURDAY: "Szombat",
  SUNDAY: "Vasárnap",
  Day: "Nap",
  Week: "Hét",
  Year: "Év",

  monday: "Hétfő",
  tuesday: "Kedd",
  wednesday: "Szerda",
  thursday: "Csütörtök",
  friday: "Péntek",
  saturday: "Szombat",
  sunday: "Vasárnap",
  day: "nap",
  week: "hét",
  today: "Ma",
  yesterday: "Tegnap",
  currentMonth: "Aktuális hónap",
  previousMonth: "Előző hónap",
  currentWeek: "Aktuális hét",
  previousWeek: "Előző hét",
  currentYear: "Aktuális év",
  previousYear: "Előző év",
  pastYear: "Elmúlt év",

  weekend: "Hétvégék",
  months: "Hónap",
  weeks: "Hetek",

  // Footer
  copyright: "Minden jog fenntartva ©",
  privacyStatement: "Adatkezelési beleegyezés",
  more: "Továbbiak",

  // Common
  serverNotResponding: "A szerver nem elérhető.",
  loading: "Betöltés...",
  pageNotFound: "Az oldal nem található.",
  incorrectFieldValue: "Néhány adat hibásan van kitöltve.",
  yes: "Igen",
  no: "Nem",
  OR: "VAGY",
  or: "vagy",
  selectAll: "Összes kijelölése",
  all: "Összes",
  optional: "opcionális",
  charactersLeft: "{0} karakter maradt",
  charactersAbove: "{0} karakterrel több",
  minimumCharacters: "A mezőnek legalább {0} karakter hosszúnak kell lennie.",
  maximumCharacters: "A mező legfeljebb {0} karakter hosszú lehet.",
  useCustomValue: "Saját érték használata:",
  show: "Megnéz",
  showMore: "Mutass többet",
  showLess: "Mutass kevesebbet",
  systemId: "Rendszer azonosító",
  here: "itt",
  moreInformation: "További információ",
  example: "Példa",
  avarage: "Átlag",

  // Error messages
  notAllowedCharacter: "Nem megengedett karakter",
  notAllowedCharacterSpecific: "Nem megengedett karakter ({0}), ellenőrizze a Num lock kapcsolót.",
  pleaseFillRequiredFields: "Kérjük töltsd ki a hiányzó mezőket.",
  numberMustBePositive: "Pozitív szám legyen.",
  numberMustBeAnInteger: "Kerek szám legyen.",
  numberMustBeLessThan: "A beírt szám {0}-nél kisebb legyen.",
  profitMarginMustBeLessThan100: "A haszonkulcs nem érheti el a 100%-ot.",
  discountMustBeLessThanTotal: "A kedvezmény összege nem lehet nagyobb a végösszegnél.",
  dateOfBirthCanNotBeInTheFuture: "A születési dátum nem lehet a jövőben.",
  tooOldDate: "A megadott dátum túl régi.",
  zipIsTooLong: "Az irányítószám túl hosszú. Az irányítószám maximum 6 számjegyű lehet.",

  // Nav
  myOrganizations: "Vállalkozásaim",
  createNew: "Új létrehozása",
  noActiveClinic: "Nincs aktív rendelő kiválasztva",
  pleaseChooseClinic:
    "Válasszon aktív rendelőt, vagy hozzon létre új vállalkozást, vagy új rendelőt meglévő vállalkozáshoz.",
  setActiveClinic: "Válassz rendelőt!",
  search: "Keresés",
  searchPetOrOwner: "Kedvenc- vagy gazdikereső",
  searchPetOwner: "Gazda keresése",
  myPets: "Állataim",
  pets: "Házikedvencek",
  addPet: "Állat hozzáadása",
  findVet: "Rendelő keresése",
  settings: "Beállítások",
  noResult: "Nincs találat.",
  noPetResult: "Nincs ilyen állat.",
  noResultTypeCustomValue: "Nincs találat, gépelj saját értéket",
  noDataYet: "Nincs még adat.",
  findClinic: "Rendelő keresése",
  findClinicByMap: "Rendelő keresése térképen",
  finish: "Lezárás",
  energySaveMode: "Energiatakarékos üzemmód",
  debugMode: "Debug mód",
  darkMode: "Sötét mód",
  contactSupport: "Írj nekünk",
  searchingPets: "Állatok keresése...",
  searchingOwnersWithoutPets: "Állat nélküli gazdák keresése...",

  // login
  login: "Bejelentkezés",
  signIn: "Bejelentkezés",
  signInToYourAccount: "Jelentkezzen be a fiókjába",
  logout: "Kijelentkezés",
  signOut: "Kijelentkezés",
  switchAccount: "Fiókváltás",
  profile: "Profil",
  profileSettings: "Profilbeállítások",
  yourProfile: "Az ön profilja",
  setupYourProfileLater: "Profil beállítása később?",
  password: "Jelszavad",
  petOrDoctor: "Ön állattulajdonos vagy orvos?",
  loginPetOwnerLabel: "Gazdi",
  loginVeterinaryWorkerLabel: "Állatorvosi dolgozó",
  registration: "Regisztráció",
  signUp: "Regisztráció",
  signUpHere: "Regisztráljon itt",
  loginWithFacebookText: "Folytatás a Facebookkal",
  loginWithGoogleText: "Folytatás a Google-lal",
  forgotPassword: "Elfelejtette a jelszavát?",
  newPassword: "Új jelszó",
  newPasswordAgain: "Új jelszó újra",
  savePassword: "Jelszó mentése",
  noAuthForLogin: "Nincs hozzáférése, hogy itt bejelentkezhessen.",
  workerLoginDisabled: "Nincs hozzáférése a dolgozói felülethez.",
  thirdPartyCookiesMustBeEnabled: "Engedélyeznie kell a harmadik féltől érkező sütiket a böngészőben.",
  areYouPetOwner: "Háziállatod van?",
  areYouClinicEmployee: "Rendelőben dolgozol?",
  petOwnerMode: "Gazda mód",
  employeeMode: "Rendelő mód",
  continueAsOwner: "Így folytatom",
  continueAsEmployee: "Így folytatom",
  ownerSideInfo: "Kövesd kedvenced adatait, és érd el könnyedén az állatorvost.",
  employeeSideInfo: "Mindent megtalálsz egy helyen: rendelő, páciensek, időpontok.",
  changeRoleInfo: "Bármikor válthatsz az orvos- és a gazdimód között a profilod menüjében.",
  saveAndContinue: "Mentés és folytatás",
  alreadyHaveAccount: "Van már fiókod?",
  noAccountYet: "Nincs még fiókod?",
  loginHere: "Belépés itt",
  signInHere: "Lépj be itt!",
  backToLogin: "Vissza a bejelentkezéshez",

  // Multi-factor authentication
  mfaAuthentication: "Azonosítás",
  mfaDescriptionSms: "Kérjük, írja be az SMS-ben kapott kódot, hogy igazolja személyazonosságát.",
  mfaDescriptionEmail:
    "Kérjük, írja be az emailen kapott kódot, vagy kattintson az emailben levő gombra, hogy igazolja személyazonosságát.",
  mfaCancel: "Bezárás",
  mfaConfirm: "Megerősítés",
  mfaLoginFailed: "Sikertelen belépés.",
  mfaInvalidCodeFormat: "Érvénytelen formátum, 6 számjegynek kell lennie.",
  enterVerificationCode: "Írd be az ellenőrző kódot",

  // Globalvet settings
  afterAcceptContractText: "Gratulálunk, mostantól a teljes GlobalVet használható!",
  navigateToYourClinicPageLink: "Látogasson el a rendelő oldalára",
  navigateToYourClinicPage: " és folytassa a felfedezést a GlobalVet rendszerében.",

  // ClinicInvoices
  from: "Ettől",
  to: "Eddig",
  invoiceState: "Számla állapota",
  invoiceCreationDate: "Számla kelt",
  pdfNotAvailable: "Sikertelen PDF letöltés",
  sendReminder: "Emlékeztető küldése",
  invoiceBillingInProgress: "Függőben lévő számlák",
  invoiceBilled: "Beküldött számlák",
  emailReminderSent: "Emlékeztető elküldve",
  withdrawingSuccessful: "A számla visszavonása sikeres volt",
  warningYouAreAboutToWithdrawAnInvoice: "Számla visszavonására készülsz.",
  warningWithdrawCostAccountings: "A számla visszavonásával a hozzá tartozó fizetési előzmények automatikusan törlődnek.",
  withdrawInvoiceNotPossible: "A visszavonás nem engedélyezett, mivel a számlához már befizetés lett rögzítve.",
  addProducts: "Termékek hozzáadása",
  paymentAndCustomerInfo: "Fizetés és számlázási adatok",
  itemsAdded: "Hozzáadott tételek",
  proceedToInvoices: "Tovább a számlákhoz",
  tryLater: "Később próbálkozom",
  type: "Típus",
  searchToolTip: "Ügyfél név, telefonszám, e-mail cím, állat neve",
  dateFilterToolTip: "Szűrés létrehozás dátumára. Szűrés részleges vagy teljes befizetés dátumára.",
  custom: "Saját",
  copyAsNew: "Másolás újként",
  addAllItemsToo: "Raktári tételek hozzáadása",
  addAllFeesToo: "Szolgáltatások hozzáadása",

  // Registration
  registerWithFacebookText: "Regisztráció Facebook fiókkal",
  registerWithGoogleText: "Regisztráció Google fiókkal",
  confirmEmailOk: "A megerősítő emailt elküldtük erre a címre: ",
  emailAlreadyUsed: "Ez az emailcím foglalt.",
  phoneAlreadyUsed: "Ez a telefonszám foglalt: ",
  emailAddress: "Email cím",
  enterYourEmail: "Add meg az email címed!",
  emailNotValid: "Érvénytelen email formátum.",
  verifyYourEmail: "Erősítsd meg az email címed!",
  emailVerification: "Email cím megerősítés",
  emailVerificationLinkInvalid: "A megerősítő link érvénytelen, kérjük próbálja újra.",
  choosePassword: "Válassz jelszót!",
  passwordValid:
    "A jelszónak tartalmaznia kell legalább 1 kisbetűt, 1 nagybetűt, 1 számot, és legalább 8 karakteresnek kell lennie.",
  confirmPassword: "Jelszavad megerősítése",
  confirmValid: "A két jelszónak meg kell egyeznie.",
  createAccount: "Fiók létrehozása",
  mobilePhone: "Mobiltelefon",
  mobilePhoneNumber: "Mobiltelefonszám",
  primaryPhoneNumberDetails:
    "Az elsődleges telefonszámodnak egy {0} kell lennie. Később hozzáadhatsz egy vezetékes telefonszámot is.",
  addNewPhoneNumber: "Új telefonszám megadása",
  primaryPhoneNumberDetailsMobilePhone: "mobiltelefonszámnak",
  landlinePhone: "Vezetékes telefon",
  phoneNotValid: "Érvénytelen telefonszám",
  publicForVeterinaryWorkers: "Állatorvosi dolgozók számára nyilvános",
  prefix: "Titulus",
  prefixPlaceholder: "pl. Dr.",
  firstName: "Keresztnév",
  middleName: "Második keresztnév",
  lastName: "Vezetéknév",
  invalidPhoneNumber: "Érvénytelen telefonszám:",
  allowNotifications: "Engedélyezed az értesítéseket?",
  allowNotificationsButton: "Engedélyezem az értesítéseket",
  notificationInfo: "Ha nem szeretnél lemaradni fontos, befoglalt időpontjaidról, engedélyezd az értesítéseket.",
  receiveSMSNotifications: "Értesítsen SMS-ben a fontos eseményekről",
  errorAccessingSocialData: "Hiba történt a szolgáltatótól való adatlekérdezés során.",
  accountAlreadyExists: "Ez a felhasználó már regisztrálva van.",
  successfulRegistration: "Sikeres regisztráció.",
  haveVetRegistrationNumber: "Állatorvosi dolgozó vagyok állami azonosító jellel.",
  registrationNumber: "Azonosító jel",
  addRegistrationNumber: "Azonosító hozzáadása",
  vetRegistrationNumbersTitle: "Állatorvosi azonosítók",
  registrationSuccessful: "Sikeres regisztráció",
  registrationSuccessfulMessage: "Gratulálunk! Sikeresen létrehozta fiókját. Üdvözöljük a GlobalVET-ben!",
  continueRegistrationMessage: "A regisztrációs folyamatot folytathatja a profilja beállításával a bejelentkezés után.",
  goToSignIn: "Tovább a bejelentkezéshez",
  pleaseCheckYourEmailInbox: "Kérlek, nézd meg a beérkező leveleid között.",
  sentYouEmailLink: "Elküldtük az aktiváló linket emailcímedre: {0}",
  pleaseCheckSpam: "Nézd meg a spam mappádat is, hátha odakerült.",
  autoLoginChooseRole: "Kérjük válasszon, hogy állattulajdonosként vagy állatorvosi dolgozóként szeretne belépni.",
  autoLogin: "A bejelentkezés automatikusan megtörténik.",
  iHaveReadAndAcceptPolicy: "Elolvastam, és tudomásul vettem az ",
  iHaveInformedOwnerAboutPolicy:
    "Az állat tulajdonosát tájékoztattam a rendelő adatakezelési irányelveiről és arról, hogy a GlobalVET AB a rendelő nevében adatfeldolgozást végez.",
  pin: "PIN kód",
  setPin: "PIN kód beállítása",
  usePinInfoTitle: "Kényelmes és biztonságos használat",
  usePinInfo: "Az alkalmazás kényelmes és biztonságos használatához adjon meg egy PIN kódot.",
  pinUsage: "Gyors átjelentkezéshez és orvosi megerősítéshez.",
  pinFormat: "A PIN kód négy számjegyű kell legyen",
  savePin: "PIN kód mentése",
  pinSaved: "PIN kód sikeresen elmentve.",
  enterPin: "Írja be a PIN kódját.",
  vetNumber4digits: "Az azonosítónak 4 számjegyből kell állnia",
  countryFieldToolTip: "Az ország, melyben állatorvosi szolgáltatást nyúlt, vagy vesz igénybe.",
  countryOfResidence: "Tartózkodási ország",
  createPetOwner: "Új gazda létrehozása",
  gdprAgreement: "Elfogadom a GlovalVET {0}",
  gdprAgreementGdpr: "adatkezelési irányelveit",
  clinicCreationAgreement: "Elfogadom a GlobalVET {0} és {1}.",
  clinicCreationAgreementGeneral: "Általános Szerződési Feltételeit",
  clinicCreationAgreementDataProcessing: "Adatfeldolgozási Feltételeit",
  fillMissingData: "Hiányzó adatok felvitele",
  searchPetOwnersToolTip: "Ügyfél név, személyi szám, telefonszám, e-mail cím, vagy állat neve",
  registrationNumberLabelForSoleProprietorship: "Nyilvántartási szám",

  // Password Recovery
  passwordRecovery: "Jelszó visszaállítása",
  recoveryEmailOk: "A visszaállító emailt elküldtük erre az email címre: ",
  recoverySmsOk: "A visszaállító SMS-t elküldtük erre a telefonszámra:  ",
  userNotFoundWithThisEmail: "Nem található felhasználó ezzel az email címmel.",
  userNotFoundWithThisPhone: "Nem található felhasználó ezzel a telefonszámmal.",
  sendRecoveryEmail: "Visszaállító email elküldése",
  sendRecoverySms: "SMS-kód küldése",
  recoverViaEmail: "Visszaállítás emailen keresztül",
  recoverViaMobile: "Visszaállítás mobiltelefonon keresztül",
  emailSentSuccessfully: "Sikeres e-mail küldés.",

  // Error boundary
  simpleError: "Hiba történt.",
  moreDetails: "Több részlet",
  lessDetails: "Kevesebb részlet",

  // AddNewPet
  newPet: "Új állat",
  addNewPet: "Új állat hozzáadása",
  newPetAndOwner: "Új állat és tulajdonos",
  newOwner: "Új tulajdonos",
  createNewOwner: "Új tulajdonos létrehozása",
  name: "Név",
  gender: "Nem",
  color: "Szín",
  species: "Faj",
  breed: "Fajta",
  dateOfBirth: "Születési dátum",
  known: "Ismert",
  estimated: "Becsült",
  unknown: "Nem ismert",
  invalidDate: "Érvénytelen dátum.",
  invalidAge: "Érvénytelen kor.",
  year: "év",
  years: "év",
  month: "hó",
  monthCnt: "hó",
  createProfileForPet: "Profil létrehozása",
  chipNumber: "Chipszám",
  tattooNumber: "Tetoválási szám",
  noPetYet: "Férj hozzá egyszerűen kedvenced egészségügyi adataihoz.",
  addFirstPetTitle: "Add meg első kedvenced adatait",
  addFirstPetButton: "Add meg kedvenced adatait",
  previousMatch: "Előző találat",

  // Edit Pet
  discardChanges: "Változtatások visszavonása",
  editPet: "Állat szerkesztése",
  seeAllPets: "Összes állat megtekintése",
  seeAllHistory: "Összes előzmény megtekintése",

  // Pet profile
  ownerPhone: "Gazda telefonszáma",
  applyFilters: "Szűrők alkalmazása",
  petProfile: "Állat adatlapja",
  editProfile: "{0} profiljának szerkesztése",
  ownerProfile: "Gazda adatlapja",
  searchBreed: "Fajta keresése...",
  uncompleted: "kitöltés alatt",
  mixed: "Keverék",
  specifyBreed: "Fajta megnevezése",
  deleteClinicPet: "Állat törlése",
  deletePetOwner: "Gazda törlése",

  // Pending pets
  pendingPets: "Függőben lévő állatok",
  seeAllPendingPets: "Összes függőben lévő állat megtekintése",
  acceptOwnership: "Legyen az én állatom",
  declineOwnership: "Elutasítás",
  changeOwner: "Gazda csere",
  currentPetOwner: "Aktuális gazda",
  addNote: "Üzenet hozzáadása",
  note: "Üzenet",
  clinicHasRegisteredYourPet: "{0} rendelő regisztrálta az állatodat.",
  createNewPet: "Új állat",
  updateExistingPet: "Meglévő állat kiegészítése",
  areYouSureToDecline: "Biztosan nem Ön az állat gazdája?",
  waitingForOldOwner: "Várakozás az előző gazdára, hogy elfogadja {0} gazda cseréjét.",
  waitingForNewOwner: "Várakozás az új gazdára, hogy elfogadja {0} gazda cseréjét.",
  acceptAsNewOwner: "{0} Önt jelölte meg {1} állata új gazdájaként",
  acceptAsOldOwner: "{0} elfogadta {1} gazda cseréjét. Ön is megerősíti a cserét?",
  newOwnerEmail: "Új gazda e-mail címe",

  // Email sending
  emailTo: "Címzett",
  emailSubject: "Tárgy",
  emailMessage: "Üzenet",
  attachToEmail: "Csatolás e-mailhez",
  emailSend: "Küldés",
  newEmail: "Új e-mail",
  defaultInsuranceEmailTitle: "Állatorvosi dokumentumok, {0} ({1})",
  petOwnerEmails: "petOwnerEmails",

  // MainOwner
  MAIN: "Kezdőlap",
  MY_PETS: "Állataim",
  APPOINTMENTS: "Foglalások",
  PRESCRIPTIONS: "Receptek",
  INVOICES: "Számláim",
  FIND_CLINIC: "Rendelő keresése",
  mainPage: "Kezdőlap",
  myBills: "Számláim",
  myAppointments: "Időpontjaim",
  addAppointment: "Új időpont",
  reserveButtonText: "Foglalás megerősítése",
  organization: "Szervezet",
  clinic: "Rendelő",
  date: "Dátum",
  reservationType: "Foglalás típusa",
  vet: "Állatorvos",
  pet: "Állat",
  newAppointmentSubTitle1: "Rendelő kiválasztása",
  newAppointmentSubTitle2: "Szolgáltatás kiválasztása",
  newAppointmentSubTitle3: "Dátum és idő választása",
  newAppointmentSubTitle4: "Háziállat kiválasztása",
  minutes: "perc",
  appointmentType: "Időpont típusa",
  appointmentCollaborator: "Állatorvos vagy asszisztens",
  appointmentErrorGDPR: "Kérünk fogadd el a beleegyező nyilatkozatot.",
  appointmentErrorTimeAndDate: "Kérünk válassz ki egy időpontot a naptárból.",
  appointmentErrorNoPet: "Az időpontfoglaláshoz szükséged lesz egy regisztrált állatra.",
  noClinicsVisitedYet: "Nem jártál még rendelőben.",
  countryOrCity: "Ország vagy város",
  HU: "Magyarország",
  SE: "Svédország",
  noAppointmentsYet: "Nincs még időpontod.",

  // ProfilePet
  dontHaveAccessToPetProfile: "Nincs hozzáférésed ennek az állatnak a profiljához.",
  appointments: "Időpontok",
  pictureAlt: "Kép",
  warningChipNumberNotConfirmed: "A chipszám még nincs megerősítve.",

  // CalendarDayViewForm
  chooseCollab: "-- Válassz munkatársat --",
  searchEmployee: "Munkatárs keresése...",
  assistant: "Asszisztens",
  authorizedAssistant: "Autorizált asszisztens",
  receptionist: "Recepciós",
  Vet: "Állatorvos",
  areYouSure: "Biztos vagy benne?",
  deleteConfirmationTitle: "Törlés megerősítése",
  deleteConfirmation: "Biztosan ki szeretnéd törölni ezt a tételt?",
  backToCalendar: "Vissza a naptárra",
  editDailyForm: "Napi nézet szerkesztése",
  collaborators: "Munkatársak",
  id: "Azonosító",
  startTime: "Kezdés",
  endTime: "Befejezés",
  modify: "Módosít",
  addCollab: "Munkatárs hozzáadása",
  deleteAll: "Összes törlése",
  addNewCollab: "Új munkatárs hozzáadása",
  roleOfChosenCollab: "Választott munkatárs munkaköre",
  repetition: "Ismétlődés",
  turnedOff: "Kikapcsolva",
  turnedOn: "Bekapcsolva",
  turnOffRepetition: "Ismétlődés ki- és bekapcsolása",
  chooseRepfordays: "Ezeken a napokon ismétlődjön:",
  setRepforWeeks: "Ennyi hét után",
  onThisDate: "Ekkor",
  end: "Vége",
  save: "Mentés",
  cancel: "Mégse",
  noShiftAtThisTime: "Ebben az időpontban nincs szabad munkatárs.",

  // PetVetData related strings
  searchChipLabel: "Keresés chipszám alapján (PetVetData)",
  checkCredentialsButton: "Felhasználónév és jelszó beírása újra.",
  petVetDataCredentials: "PetVetData belépési adatok",
  usernameLabel: "Felhasználónév",
  passwordLabel: "Jelszó",
  enterChipNumberMessage: "Add meg az állat chipszámát, majd Enter/keresés gomb után lehívjuk a PetVetData adatait.",

  downloadMedicalRecordPDF: "Kórlap letöltése (PDF)",
  downloadInvoicePDF: "Számla letöltése (PDF)",
  downloadPDF: "PDF letöltése",
  openMedicalRecord: "Kórlap megnyitása",
  corrected: "Javítva",
  underCorrection: "Javítás alatt",

  // Substitution form
  substitution: "Helyettesítés",
  substitutionTitle: "Foglalások helyettesítése",
  absentEmployee: "Helyettesítendő munkatárs",
  startDate: "Kezdő dátum",
  endDate: "Befejező dátum",
  startDateTime: "Kezdeti dátum és idő",
  endDateTime: "Vége dátum és idő",
  noReservationsSaveSubstitution:
    "{0} felhasználónak nincs jövőbeli időpontfoglalása {1} és {2} között. Törölheti a műszakjait.",
  cancelAndNotifyPetOwner: "Időpont lemondása és gazdi értesítése",
  chooseSubstitute: "-- Helyettes kiválasztása vagy időpont lemondása --",
  substitute: "Helyettesítés",
  employeeToDelete: "Helyettesítendő munkatárs",
  saveAndDeleteEmployee: "Mentés és munkatárs törlése",
  userHasReservationsBetween:
    "{0} felhasználónak {1} és {2} között foglalásai vannak. Állíts be helyetteseket, vagy mond le a foglalásokat.",
  deleteShifts: "Műszakok törlése",
  deleteShift: "Műszak törlése",
  areYouSureToDeleteShift: "Biztosan törölni szeretné ezt a műszakot?",
  deleteShiftsFor: "Műszakjainak törlése",
  selectShiftsFrom: "Műszakok keresése ettől",
  startOfShift: "Műszak kezdete",
  endOfShift: "Műszak vége",
  startDateEndDateErrorMsg: "A műszak nem kezdődhet a műszak vége után",
  tooLongShiftErrorMsg: "A műszak túl hosszú. Maximális időtartam: 24 óra.",

  // Statistics
  statistics: "Statisztikák",
  payments: "Befizetések",
  Month: "Hónap",
  amount: "Összeg",
  status: "Állapot",
  pay: "Befizet",
  paySelected: "Kijelöltek befizetése",
  payWithRegisteredCard: "Fizetés regisztrált kártyával",
  payWithDifferentCard: "Fizetés más kártyával",
  paymentSuccessful: "Sikeres befizetés.",
  paymentUnSuccessful: "Sikertelen befizetés.",
  cause: "Indok",
  downloadInvoicePdf: "Számla letöltése",
  paymentsToolTip: "GlobalVet által kiállított számlák és befizetések kezelése.",
  costSummaryToolTip: "Rendelő havi költségei.",
  revenue: "Árbevétel",
  outstandingBalance: "Kintlévőség",
  readyForPaymentBalance: "Fizetésre kész",
  noPaymentMethodHistoryInfo: "Nincsenek fizetések ebben az időtartományban.",

  // Verification
  emailVerificationIsSuccessful: "Sikeresen megerősítetted az email címedet.",
  emailVerificationIsSuccessfulInfo:
    "Most már bezárhatod ezt a fület vagy folytathatod a folyamatot a bejelenkezéssel.",
  errorDuringEmailVerification: "Probléma merült fel az email megerősítése során.",
  confirmEmail: "Megerősítő email",
  goToLogin: "Vissza a bejelentkezéshez",
  goToMainPage: "Vissza a főoldalra",
  redirectInSeconds: "Átirányítás {1} másodpercen belül...",

  // CreateClinic
  createFirstClinic: "Virtuális rendelő beállítása",
  createClinic: "Elindítom a rendelőmet",
  create: "Létrehozás",
  invalidAddress: "Helytelen cím",
  goToClinic: "Belépek",
  yourRole: "Mint:",
  chooseEmploymentInClinicTitle: "Munkakör választása",
  chooseEmploymentInClinicInfo: "A rendelőmben végzett tevékenységeim:",
  chooseEmploymentInClinicOption1: "Állatorvos is vagyok",
  chooseEmploymentInClinicOption2: "Asszisztens is vagyok",
  chooseEmploymentInClinicOption3: "Csak tulajdonos vagyok",
  chooseLater: "Később választod ki?",

  // Bank card and stripe
  vatNotValid: "Az adószámnak legalább 5 számjegyűnek kell lennie.",
  chargeWarning:
    "A havi díjat mindig a következő hónap első napján számoljuk fel. Az árat használat alapján határozzuk meg.",
  baseChargeWarning:
    "Ellenőrzés céljából egy kis összeggel megterhelhetjük a kártyádat, ezt a regisztráció után visszatérítjük.",

  creditCardModification: "Bankkártya adatainak módosítása",
  creditCardAuthFailed: "A bankkártyát elutasítottuk, mivel a terhelés nem sikerült. Kérjük ellenőrizd a kártyádat.",
  creditCardDeclined: "A kártyáját elutasítottuk.",
  creditCardExpired: "A kártyája lejárt.",
  incorrectCVC: "A kártyád a biztonsági kódja hibás.",
  incorrectZIP: "A kártyád a ZIP kódja hibás.",
  invalidCVC: "A kártyád biztonsági kódja érvénytelen.",
  invalidNumber: "A kártyaszáma érvénytelen.",
  stripeHandleError: "A fizetésekhez kapcsolódó szolgáltatásaink jelenleg nem elérhetők. Kérjük próbáld később.",
  incorrectName: "A kártyán szereplő név hibás.",
  chargeFailed: "A befizetés sikertelen. Kérjük ellenőrizd, hogy a megadott kártya adatai helyesek-e.",
  chargeSucceeded: "A befizetés sikeresen megtörtént.",
  businessName: "Cégnév",
  businessRegistrationNumber: "Regisztrációs szám",
  invalidRegistrationNumber: "Érvénytelen regisztrációs szám",
  businessStructure: "Működési forma",
  businessNameInfo: "Ez a név fog szerepelni a GlobalVet által kiállított havi számláidon.",
  clinicNameInfo: "Időpont foglaláskor ez a név fog megjelenni a gazdik számára.",

  // EditCategory
  cannotRetriveCatData: "Nem sikerült a kategória adatait betölteni.",
  deleteError: "Hiba történt a törléskor",
  editCategory: "Kategória szerkesztése",
  createCategory: "Kategória létrehozása",
  catNameWithDots: "Kategória neve...",
  delete: "Törlés",
  deletingCat: "Kategória törlése",
  areYouSureDeleteCat: "Biztos, hogy törölni szeretnéd a(z) {0} nevű kategóriát?",
  hide: "Tételek elrejtése",
  see: "Tételek megjelenítése",
  newItem: "Új tétel",

  // EditItemModal
  cannotRetriveItemData: "Nem sikerült betölteni a tétel adatait.",
  editItem: "Tétel szerkesztése",
  createItem: "Tétel létrehozása",
  price: "Ár",
  itemPriceWithDots: "Tétel ára...",
  minimalLevel: "Alacsony feltöltöttség",
  stock: "Készlet",
  deleteItem: "Tétel törlése",
  areYouSureDeleteItem: "Biztos, hogy törölni szeretnéd a(z) {0} nevű tételt?",
  chooseSpecies: "Válassz fajt!",
  nameCannotBeEmpty: "A név kitöltése kötelező.",
  itemNameWithDots: "Tétel neve...",
  itemUnitWithDots: "Tétel mértékegysége...",
  deletingItem: "Tétel törlése",
  acquisitionPrice: "Beszerzési ár",
  acquisitionVat: "Beszerzési ÁFA-kulcs",
  salePrice: "Eladási ár",
  sellingVat: "Eladási ÁFA-kulcs",
  acquisitionUnitQuantity: "Beszerzési egységmennyiség",
  acquisitionUnit: "Mértékegység",
  sellingDivisor: "Eladási mennyiség osztója",
  currency: "Pénznem",
  applicableToSpecificSpecies: "Csak bizonyos fajnál alkalmazható",
  customPrice: "Egyedi ár",

  // FindClinic
  setAddress: "Kérjük, állítds be a címed a profilodon!",
  warningUserHasNoPrimaryAddress: "Először be kell állítani egy elsődleges címet, hogy időpontot tudj foglalni.",
  warningUserHasNoPrimaryAddressLinkToProfile: "Profil beállítások módosítása.",

  // Inventory
  cannotRetriveClinicData: "Nem sikerült betölteni a rendelő adatait.",
  inventorySettings: "Raktárbeállítások",
  filter: "Szűrő",
  filters: "Szűrők",
  clearFilters: "Szűrők törlése",
  addItemFromVara: "VARA gyógyszeradatbázis",
  addItem: "Tétel hozzáadása",
  createNewInventoryItem: "Új raktári tétel létrehozása",
  noItemsAdded: "A listához még nem lett hozzáadva tétel.",
  areYouSureToDeleteCategory:
    "Biztosan törölni szeretné a raktár kategóriát? Az összes hozzá tartozó tétel is törlődni fog.",
  updateStock: "Készlet feltöltése",
  refillStock: "Bevételezés",
  resetRefillValues: "Feltöltési értékek törlése",
  inventoryItemDetails: "Raktártétel tulajdonságai",
  orderHistory: "Bevételezési előzmények",
  orderHistoryUnit: "Bevételezés",
  newOrder: "Új bevételezés",
  usageHistory: "Kiadási előzmények",
  usageHistoryUnit: "Kiadás",
  countingHistory: "Leltározási előzmények",
  countingHistoryUnit: "Leltár",
  newCounting: "Új leltározás",
  dateOfOrder: "Bevételezés dátuma",
  countedQuantity: "Leltározott mennyiség",
  countingDetails: "Leltározás részletei",
  totalQuantityInPackages: "Kiszerelés(ek)ben található mennyiség",
  unitPriceCalculator: "Egységár kalkulátor",
  totalPackagePrice: "Teljes kiszerelés ára",
  stockUsage: "Kiadás",
  editUsage: "Kiadás szerkesztése",
  editStock: "Bevételezés szerkesztése",
  deleteUsage: "Kiadás törlése",
  deleteStock: "Bevételezés törlése",
  deleteCounting: "Leltározás törlése",
  stockAddedSuccessfully: "Sikeres bevételezés.",
  stockUpdatedSuccessfully: "Bevételezés frissítve.",
  stockDeletedSuccessfully: "Bevételezés törölve.",
  countingDeletedSuccessfully: "Tétel sikeresen törölve.",
  areYouSureToDeleteItemStock: "Biztos, hogy törölni szeretnéd a(z) {0} nevű tétel bevételezését?",
  areYouSureToDeleteItemUsage: "Biztos, hogy törölni szeretnéd a(z) {0} nevű tétel kiadását?",
  areYouSureToDeleteItemCounting: "Biztos, hogy törölni szeretnéd a(z) {0} nevű tétel leltározását?",
  countInventory: "Leltározás",
  stockOperations: "Készletkezelés",
  profit: "Nyereség",
  profitMargin: "Haszonkulcs",
  profitMarginInfo: "A haszonkulcs a nyereség és a bevétel aránya.",
  currentStock: "Bevételezett készlet",
  countedStock: "Leltározott készlet",
  countingDifference: "Eltérés",
  addMissingStock: "Hiányzó bevételezés felvétele",
  finishCounting: "Leltár véglegesítése",
  stockIsTheSame: "Készlet megegyezik",
  stockIsDifferent: "Készlet különbözik",
  salePriceOverTime: "Eladási ár ({0}) az elmúlt időben",
  purchasePriceOverTime: "Beszerzési ár ({0}) az elmúlt időben",
  purchaseVsSalePriceTitle: "Beszerzési ár és eladási ár alakulása",
  skip: "Kihagyás",
  lowStockToolTipInfo: "Ennél a mennyiségnél jelez a rendszer, ha fogyóban van a tétel.",
  stockSkipped: "Bevételezés kihagyva.",
  itemCreatedSuccessfully: "A(z) {0} raktártétel sikeresen létrehozva.",
  itemUpdatedSuccessfully: "A(z) {0} raktártétel sikeresen frissítve.",
  updateSalePriceFromProfitMargin:
    "Eladási ár frissítése haszonkulcs ({0}%) alapján. Az új eladási ár: {1} (bruttó: {2}) lesz.",
  unableToSetSalePriceError: "Eladási ár automatikus frissítése nem sikerült. Manuális beállítás szükséges.",

  // Analytics
  analytics: "Kimutatások",
  notEnoughData: "Nincs elég adat",

  // InventoryStatistics
  cannotRetriveInventoryData: "Nem sikerült a rendelő raktárának adatait betölteni.",
  itemName: "Tétel neve",
  allItems: "Összes tétel",
  showOnlyLow: "Alacsony készletszintű tételek",
  showOnlyStock: "Raktáron lévő tételek",
  unprofitableItems: "Veszteséges tételek",
  category: "Kategória",
  warningAt: "Figyelmeztetés",
  lowLevel: "Alacsony mennyiség",
  searchCategory: "Kategóriák keresése",

  // InventoryStatus
  refill: "Feltöltés",
  options: "Opciók",
  edit: "Szerkesztés",
  addToTreatment: "Kezeléshez adás",
  ok: "Rendben",
  operations: "Műveletek",
  saveChanges: "Változtatások mentése",

  // Invoice History
  costAccounting: "Költségelszámolás",
  treatmentData: "Kezelés adatai",
  invoiceDetails: "Számla adatai",
  code: "Kód",
  clinicIdentifier: "Rendelő azonosító",
  totalCost: "Összköltség",
  remainingCost: "Fennmaradó költség",
  sendReminderEmail: "Emlékeztető email küldése",
  amountToPay: "Fizetendő összeg",
  markAsPaid: "Fizetettnek jelölés",
  partialPayment: "Részleges fizetés",
  emailReminder: "Email emlékeztető",
  addCorrection: "Javítás hozzáadása",
  paidAmount: "Fizetett összeg",
  payerName: "Fizető neve",
  payer: "Fizető",
  payerType: "Fizető fél",
  PET_OWNER: "Állattulajdonos",
  INSURANCE_COMPANY: "Biztosítótársaság",
  paymentMethod: "Fizetési mód",
  paymentMethodShort: "Mód",
  newRemainingCost: "Fennmaradó összeg",
  customer: "Vevő",
  issuer: "Számla kibocsátója",
  paymentHistory: "Fizetési előzmények",
  modifierParty: "Módosító",
  paymentType: "Fizetés típusa",
  warningYouAreAboutToSendEmail: "Biztos vagy benne, hogy elküldöd az emailt?",
  emailReminders: "Elküldött emlékeztetők",
  onlinePayment: "Online fizetés",
  creditCardDetails: "Bankkártyaadatok",
  bankCard: "Bankkártya",
  noData: "N/A",
  noInvoiceHistoryData: "Nincsenek fizetési előzmények.",
  notPaid: "Nem fizetett",
  filterDateType: "Dátum típusa",
  filterByDateOfIssue: "Szűrés kiállítás dátuma szerint",
  filterByDateOfPayment: "Szűrés fizetés dátuma szerint",
  filterByName: "Szűrés név szerint",
  allowOnlinePaymentAndSendEmail: "Online fizetés engedélyezése és fizetési link küldése emailben",
  invoiceSent: "Beküldve",
  sentToFortnox: "Beküldve a Fortnox rendszerébe",
  sentToSzamlazz: "Beküldve a Számlázz.hu rendszerébe",
  failedToSendToFortnox: "Nem sikerült beküldeni a Fortnox rendszerébe",
  failedToSendToSzamlazz: "Nem sikerült beküldeni a Számlázz.hu rendszerébe",
  failedToConnectToFortnox: "Nem sikerült kapcsolódni a Fortnox rendszerhez",
  sendToFortnox: "Beküldés a Fortnox rendszerébe",
  sendToSzamlazz: "Beküldés a Számlázz.hu rendszerébe",
  fortnox: "Fortnox",
  szamlazz: "Számlázz.hu",
  szamlazzIntegrationInfo1:
    "A számlázz.hu integrálása a Számla Agent szolgáltatás segítségével történik. Kérjük másold be a Számla Agent API kulcsodat a számlázz.hu oldalról. {0}",
  szamlazzIntegrationInfo2:
    "Az automatikus számlázáshoz csak a vállalkozás Számla Agent kulcsát kell bemásolni a számlázz.hu oldaláról:",
  invoicingMethodNone: "Egyik sem",
  explanation: "Magyarázat",
  paymentDetails: "Fizetés részletei",
  paymentState: "Fizetési állapot",
  retry: "Újrapróbálkozás",
  noEmailReminderSent: "Nincs kiküldött emlékeztető email",
  download: "Letöltés",
  print: "Nyomtatás",
  printOrDownloadInvoice: "Szeretnéd letölteni vagy kinyomtatni a számlát?",
  noInvoicesToDisplay: "Nincs megjelenítendő számla",
  withdrawInvoice: "Számla visszavonása",
  estimatedCost: "Becsült költség",
  goToInvoices: "Számlák kezelése",
  editInvoice: "Számla szerkesztése",
  pendingInvoice: "Függőben",
  plusVat: "+ ÁFA",
  invalidAmount: "Érvénytelen összeg",
  gross: "bruttó",
  net: "nettó",
  grossPrice: "Bruttó ár",
  netPrice: "Nettó ár",
  cashIncome: "Készpénzes",
  cardIncome: "Bankkártyás",
  transferIncome: "Átutalásos",
  directDebitIncome: "Beszedési megbízás",
  onlineIncome: "Online (Stripe)",
  insuranceIncome: "Biztosító",
  totalIncome: "Teljes bevétel",
  paymentSummary: "Fizetési összesítő",
  invoicingMethod: "Kibocsátás módja",
  costSummary: "Költségösszegzés",
  incomeSummary: "Bevételek",
  downloadIncomeSummary: "Bevételösszesítés letöltése",
  printIncomeSummary: "Bevételösszesítés nyomtatása",
  totalIncomeIsZeroInfo: "A bevétel összege nulla.",
  sales: "Eladás",
  newSale: "Új eladás",
  needInvoice: "Beküldés a Fortnoxba",
  invoicingSystemIsNotIntegrated: "A rendelő nincs összekapcsolva külső számlázóval.",
  goTo: "A {0} oldalon megnézheted az elérhető integrációkat.",
  sameAsCustomerData: "Megegyezik a vevő adataival",
  billingInfo: "Számlainformáció",
  invoiceHasBeenSentInEmail: "A számla el lett küldve a következő e-mail címre:",
  pleaseConfirmMarkAsPaid: "Kérjük erősítse meg a fizetést:",
  successfullyPaid: "A számla sikeresen fizetettnek lett jelölve.",
  seeAllPaymentHistory: "Összes fizetési előzmény",
  seeAllEmailReminders: "Összes e-mail emlékeztető",
  seeAllInvoiceItems: "Összes tétel",
  withdrawPayment: "Fizetés visszavonása",
  payment: "Fizetés",
  paidImmediately: "A teljes összeg azonnal fizetve lesz a klinikán",
  dueDateForPayment: "Fizetési határidő",
  dueDate: "Határidő",
  invoiceCreated: "Sikeres számlalétrehozás",
  deleteInvoice: "Számla törlése",
  withdrawReadyForPayment: "'Fizetésre kész' visszavonása",
  insuranceTitle: "Részszámla",
  payLater: "Fizetés később",
  payNow: "Fizetés most",
  invoiceNumber: "Számlaszám",
  invoiceSearchCategory: "Keresési kategória",
  invoicing: "Számlázás",
  integrationTurnedOff: "A {0} számlázó sikeresen kikapcsolva.",
  noInvoicingSystemSupported: "Ebben az országban nincs a GlobalVet által támogatott számlázórendszer.",
  discountName: "Kedvezmény megnevezése",
  discountTypeLabel: "Kedvezmény összege (bruttó)",
  fixDiscount: "Fix kedvezmény",
  percentDiscount: "Százalékos kedvezmény",

  // MainDoctor
  welcome: "Üdvözöljük",
  changeClinic: "Átváltás másik rendelőre",
  selectNone: "Egyik se",
  selectActiveClinic: "Aktuális rendelő kiválasztása",
  as: " {0}ként",
  activeClinic: "Aktuális rendelő",
  pleaseSelectActiveClinic: "Kérem, válassza ki a rendelőt, ahol dolgozni szeretne",
  pending: "Függőben lévő kérésed van {0} felhasználótól, hogy csatlakozz {1} nevű rendelőhöz {2}ként",
  pendingRequest: "Függőben lévő felkérés",
  employmentRequestAccepted: "Felkérés elfogadva",
  noReservaionsOnThisDay: "Erre a napra nincsenek foglalások és műszakok rögzítve.",
  noShiftsOnThisWeek: "Erre a hétre nincs műszak rögzítve.",
  newShift: "Új műszak",
  createShift: "Műszak felvétele",
  noReservationsFound: "Ezen a napon nincs még foglalás.",
  pleaseCheckTheLocation: "Kérem, jelölje be a helyszínt a térképen.",
  owners: "Gazdák",
  noClinicPetOwnersYet: "Nincs még gazda.",
  areYouSureDeletePetOwner:
    "Biztosan törölni szeretnéd ezt a gazdát? A gazdához tartozó állatok adatai is végleg el fognak tűnni.",
  areYouSureDeletePet: "Biztosan törölni szeretnéd ezt az állatot?",
  skipForNow: "Folytatás később",
  addItLater: "Később szeretnéd hozzáadni?",
  setItLater: "Később szeretnéd beállítani?",
  setPinNumber: "PIN kód beállítása",
  noClinicYet: "Indítsd el a saját rendelődet egyszerűen!",
  pendingInvitations: "Függőben lévő meghívók",

  // Management
  fees: "Díjak",
  country: "Ország",
  chooseCountry: "Válassz országot!",
  baseFeeForClinic: "Rendelők alapdíja",
  baseFeeForEmployee: "Dolgozók havi alapdíja",
  baseFeeForVet: "Állatorvosok havi alapdíja",
  baseFeeForAssistant: "Asszisztensek havi alapdíja",
  baseFeeForReceptionist: "Recepciósok havi alapdíja",
  appointmentFee: "Időpontfoglalások díja",
  medicalRecordFee: "Kórlap díja",
  smsFee: "SMS díja",
  inventoryUsageFee: "Raktár használati díja",
  currencyValid: "A valutának muszáj két számjegyre kerekített értéknek lennie.",
  selectedCurrency: "A választott ország valutája: {0}",
  editDiscounts: "Kedvezmények szerkesztése",
  discounts: "Kedvezmények",
  existingDiscounts: "Jelenlegi kedvezmények",
  resetSettings: "Alaphelyzet",
  freeSubscription: "Ingyenes előfizetés",
  active: "Aktív",
  originalPrice: "Eredeti ár",
  discountedPrice: "Kedvezményes ár",
  warningSaveDiscount: "Az előfizetés módosításával a kiválasztott rendelő költségszámítása azonnal megváltozik.",
  warningSaveCountryFees: "A tarifák módosításával az érintett klinikák költségszámítása azonnal megváltozik.",
  globalSettings: "Beállítások",
  policies: "Szerződések",
  unemployedWorkerLoginEnabled: "Dolgozói bejelentkezés engedélyezése munkaviszony nélküli felhasználók számára",
  existingPrivacyPolicies: "Létező adatvédelmi irányelvek",
  createPrivacyPolicy: "Adatvédelmi irányelvek létrehozása",
  editPrivacyPolicy: "Adatvédelmi irányelvek szerkesztése",
  languages: "Nyelvek",
  version: "Verzió",
  grammarChange: "Csak nyelvtani módosítás.",
  infoNoNewVersion: "Nem fog új verzió keletkezni, ha be van jelölve ez a mező.",
  successfulSave: "Sikeres mentés.",
  addPolicy: "Irányelv hozzáadása",
  editPolicy: "Irányelv módosítása",
  deletePolicy: "Irányelv törlése",
  deletePolicyConfirmation: "Biztosan ki akarja törölni ezt az irányelvet?",
  warningDeletePolicy: "A létező nyilatkozatok archiválódnak az esetleges jogviták rendezésének érdekében!",
  privacyPolicy: "Adatvédelmi irányelvek",
  manageCookies: "Sütik kezelése",
  gdprConsent: "GDPR Hozzájárulás",
  generalTermsAndConditions: "Általános Szerződési Feltételek",
  dataProcessingTermsAndConditions: "Adatfeldolgozási Feltételek",
  policyStatement: "Nyilatkozat",
  insuranceCompany: "Biztosító",
  insuranceCompanies: "Biztosítók",
  fax: "Fax",
  paymentTerms: "Fizetési feltételek",
  users: "Felhasználók",
  profilePicture: "Profilkép",
  petProfilePicture: "Állat profilkép",
  clinicLogo: "Logó",
  facebookId: "Facebook ID",
  facebookEmail: "Facebook email",
  googleId: "Google ID",
  googleEmail: "Google email",
  ipAddress: "IP-cím",
  userAgent: "User agent",
  gdprExtractSentSuccessfully: "Kivonat sikeresen elküldve",
  sendExtractToUser: "Kivonat küldése a felhasználónak",
  changePassword: "Jelszó módosítása",
  changeVatNumber: "Adószám módosítása",
  gvAppVersions: "Alkalmazásverziók",
  gvServiceName: "Szolgáltatás",
  gvServiceVersion: "Verzió",
  gvLastCommit: "Utolsó commit",
  serviceFees: "Szolgáltatási díjak",
  customFees: "Egyedi díjak",
  minimalChargeValue: "Minimális levonható összeg",
  paymentDate: "Fizetés ideje",
  allOrganizations: "Összes szervezet",
  trialDiscountPercent: "Próbaidőszak kedvezmény",
  trialPeriodDays: "Próbaidőszak hossza",
  trialEndReminderBeforeDays: "Emlékeztető a próbaidőszak végéről",
  daysBefore: "nappal korábban",
  discount: "Kedvezmény",
  siteManagers: "Menedzserek",
  siteManager: "Menedzser",
  permissions: "Engedélyek",
  fullAccess: "Teljes hozzáférés",
  config: "Config",
  countries: "Országok",
  activeCountries: "Aktív országok",
  inactiveCountries: "További országok",
  paymentAndBilling: "Fizetés és számlázás",
  paymentSystem: "Fizetési rendszer",
  secretKey: "Titkos kulcs",
  billingSystem: "Számlázórendszer",
  clientId: "Kliens azonosító",
  clientSecret: "Kliens titok",
  testInvoices: "Tesztszámlák",
  testInvoice: "Tesztszámla",
  createTestInvoice: "Tesztszámla létrehozása",
  noTestInvoiceCreatedYet: "Még nincs tesztszámla létrehozva.",
  testInvoiceWarning:
    "Ha egy éles környezet hitelesítő adatait adtad meg, kérlek, ne felejtsd el visszavonni a létrehozott számlát a számlázási rendszeren belül.",
  insuranceInvoiceSettings: "Biztosítónak kiállított számla beállításai",
  systemIntegrations: "Rendszerintegrációk",
  systemIntegrationsAllWorking: "Az összes rendszerintegráció működik",
  discountFree: "Ingyenes",
  discountCustom: "Egyéni",
  untilWithdrawn: "visszavonásig",
  remoteAccess: "Távoli hozzáférés",
  exportClinicData: "Adatok exportálása",
  foreignClinicWarning:
    "Az oldal menedzsereként egy idegen klinikához férsz hozzá. Ügyelj rá, hogy ne hajts végre nem kívánt változtatást!",
  leaveClinic: "Klinika elhagyása",
  clinicFeatures: "Klinika funkciók",
  feature: "Funkció",
  commissionRate: "Jutalék aránya",
  discountedCommissionRate: "Jutalék kedvezményes aránya",
  originalCommissionRate: "Jutalék eredeti aránya",
  priceLists: "Árlisták",
  notificationPath: "Útvonal",
  deliveryType: "Kézbesítés módja",
  deliveryTypeEmail: "Email üzenet",
  deliveryTypeInApp: "Alkalmazáson belüli értesítés",
  deliveryTypePush: "Push értesítés",
  deliveryTypeSms: "SMS értesítés",
  newNotification: "Új értesítés",
  outgoingNotifications: "Kimenő értesítések",
  notificationsSent: "Elküldve",
  notificationsRead: "Olvasva",
  notificationTargetGroup: "Célcsoport",
  emailNotificationSubject: "Email tárgy",
  emailNotificationMessage: "Email üzenet",
  emailActionButton: "Akciógomb szövege",
  sendNotification: "Értesítés küldése",
  newNotificationTarget: "Címzett",
  newNotificationSettings: "Beállítások",
  newNotificationContent: "Értesítés",
  newNotificationEmailContent: "Email",
  newNotificationPreview: "Előnézet",
  notification: "Értesítés",
  notificationSettingsEmail: "Email",
  notificationSettingsInApp: "Alkalmazáson belül",
  notificationSettingsPush: "Push üzenet",
  notificationSettingsSms: "SMS",
  notificationSendDate: "Elküldve",
  notificationReadDate: "Olvasva",
  notificationCancelDate: "Visszavonva",
  notificationSuccessRate: "Sikerarány",
  sendTestEmail: "Teszt email küldése",

  // MedicalRecord
  open: "Megnyitás",
  examination: "Vizsgálat",
  dontHaveAccessToMedicalRecord: "Nincs hozzáférése ehhez a kórlaphoz!",
  petsMedicalRecord: "{0} kórlapja",
  unknownMedicalRecord: "Ismeretlen kórlapja",
  petOwner: "Állat tulajdonosa",
  petName: "Állat neve",
  anamnesis: "Anamnézis",
  physicalExamination: "Fizikális vizsgálat tünetei",
  diagnostics: "Műszeres diagnosztika",
  diagnosis: "Diagnózis",
  treatment: "Kezelés",
  recommendation: "Ajánlás",
  prognosis: "Prognózis",
  certificate: "Igazolás",
  referral: "Beutalás",
  changeIndicator: "Kijelző váltása",
  weights: "Súlyok",
  vaccines: "Vakcinák",
  medicines: "Gyógyszerek",
  history: "Előzmények",
  diagnoses: "Diagnózisok",
  differentialDiagnoses: "Differenciáldiagnózisok",
  treatments: "Kezelések",
  sign: "Aláír",
  signCorrection: "Javítás aláírása",
  openForCorrection: "Megnyitás javításra",
  correction: "Javítás",
  signedBy: "Aláírva",
  correctionSignedBy: "Javítás aláírva",
  signed: "Aláírva",
  correctionSigned: "Javítás aláírva",
  signMedicalRecord: "Kórlap aláírása",
  signer: "Aláíró",
  signText: "Ha aláírja {0} kórlapját, a kórlap véglegessé válik, és csak olvasható lesz.",
  addNewInfo: "Új információ hozzáadása",
  weight: "Súly",
  chooseFromWithDots: "Válassz a listából",
  close: "Bezár",
  warning: "Figyelmeztetés",
  error: "Hiba",
  itemsAtNegativeStock:
    "A raktár feltöltése valószínűleg elmaradt, és emiatt egyes tételek készlete negatív értéket vesz fel.",
  invoice: "Számla",
  cashInvoice: "Készpénzfizetési számla",
  createdBy: "Létrehozta",
  created: "Létrehozva",
  chronicDiseases: "Krónikus betegségek",
  chronicDiseaseHistoryAdded: "{0} regisztrálva.",
  chronicDiseaseHistoryRemoved: "{0} eltávolítva.",
  connectedPrescriptions: "E-receptek",
  addInventoryItems: "Eszközök hozzáadása",
  addServiceFees: "Szolgáltatások hozzáadása",
  usedItems: "Felhasznált eszközök",
  usedFees: "Használt díjak",
  usedItemsAndFees: "Felhasznált eszközök és egyéb díjak",
  noServiceFeesAdded: "A listához még nem lett hozzáadva szolgáltatás.",
  medicalRecordHistory: "Kórlap történet",
  hematology: "Hematológia",
  biochemistry: "Biokémia",
  parameters: "Paraméterek",
  conventionalUnits: "Mértékegység",
  referenceRange: "Referencia értékek",
  result: "Eredmény",
  costs: "Költségek",
  inProgress: "Kitöltés alatt",
  notStarted: "Kitöltetlen",
  otherInventoryItems: "Egyéb raktári elemek",
  deleteRelatedItems: "Kezeléshez kapcsolódó elemek törlése",
  displayPetOverview: "Összefoglaló adatok megjelenítése",
  followUp: "Egyéb",
  createInvoice: "Számla létrehozása",
  addDocuments: "Dokumentumok hozzáadása",
  addFiles: "Fájlok hozzáadása",
  fileTooLarge: "A fájl túl nagy. A legnagyobb megengedett fájlméret 10 MB.",
  mailedTo: "Elküldve",
  inventoryItems: "Raktár tételek",
  searchInventoryItems: "Tételek keresése",
  searchFees: "Szolgáltatások keresése",
  medicalRecordId: "Kórlap azonosító",
  resetTreatmentDescriptions: "Kezelésleírások visszaállítása",
  contentNotAvailable: "Nem elérhető tartalom.",

  // Prescription
  ePrescription: "E-Recept",
  pharmacy: "Gyógyszertár",
  prescription: "Recept",
  prescriptions: "Receptek",
  newPrescription: "Új recept",
  prescriptionItem: "Recept tartalma",
  addItems: "Hozzáadás",
  product: "Termék",
  substance: "Hatóanyag",
  barcode: "Vonalkód",
  formulation: "Formula",
  pharmaceuticalForm: "Gógyszer formátuma",
  typeOfPacking: "Kiszerelés típus",
  strength: "Erősség",
  manufacturer: "Gyártó",
  notAddedYet: "A recept még üres.",
  notPrescribable: "Ezt a készítményt nem lehet felírni.",
  withdrawalDate: "Visszavonás dátuma",
  details: "Részletek",
  packages: "Kiszerelések",
  packagingQuantity: "Kiszerelés darabszáma",
  ddd: "Meghatározott napi adag (DDD)",
  noDDD: "Nincs meghatározott napi adag.",
  noManufacturer: "A gyártó nem ismert.",
  addToPrescription: "Hozzáadás a recepthez",
  dosage: "Adagolás",
  instructions: "Használati utasítás",
  dose: "Adag",
  unit: "Egység",
  period: "Periódus",
  method: "Bevétel módja",
  addNewInterval: "Új időszak hozzáadása",
  expeditionInterval: "Időtartam",
  expeditionIntervalUnit: "Időegység",
  timeInterval: "Időtartam",
  timeIntervalUnit: "Időegység",
  waitingPeriods: "Karantén beállítások",
  mustBeBetween: "A számnak egésznek kell lennie, {0} és {1} között.",
  days: "napig",
  Days: "Napig",
  days2: "nap",
  Days2: "Nap",
  dayOrDays: "Nap",
  limit: "Limit",
  redemption: "Kiváltás",
  expirationDate: "Lejárati idő",
  redemptionPeriod: "Kiváltási időszak",
  firstRedemption: "Első kiváltási időszak",
  latestRequestedTimeForDispensing: "Utolsó kiváltás dátuma",
  latestRequestedTimeForDispensingDate: "Első kiváltás utolsó dátuma",
  latestRequestedTimeForDispensingDescription:
    "Az első visszavonás korlátozott érvényességének jelzésére használható. Ha a vény ezen időpontig nem került kiadásra, a teljes recept érvénytelenné válik.",
  finishPrescription: "Recept véglegesítése",
  allPharmacies: "Összes gyógyszertár",
  specificPharmacy: "Konkrét gyógyszertár",
  homeDeliveryFromSpecificPharmacy: "Házhozszállítás konkrét gyógyszertárból",
  municipality: "Község",
  chargedAutomatically: "Automatikus",
  chargedLater: "Később",
  notEnoughFields: "Nincs elég bemenet a kereséshez.",
  forPeriod: "{0} napig",
  addSpecificPharmacy: "Gyógyszertár kiválasztása",
  production: "Előállítás",
  delivery: "Átvétel",
  receiver: "Fogadó",
  verification: "Megerősítés",
  continue: "Folytatás",
  backToPrescription: "Vissza a recepthez",
  signature: "Aláírás",
  selectPharmacy: "Gyógyszertár választása",
  instructionLanguage: "Utasítások nyelve",
  unset: "Nincs beállítva",
  swedishCitizen: "Svéd állampolgár",
  swedishOrganisation: "Svéd szervezet",
  foreignCitizen: "Külföldi személy",
  organisationName: "Szervezet neve",
  organisationId: "Cégjegyzékszám",
  animalType: "Állat típusa",
  pleaseSelectIfNotSwedish: "Válasszon, ha nem svéd",
  quantityUnit: "Mértékegység",
  packageContent: "Csomag tartalma",
  licenseInformation: "Licenc információ",
  licenseId: "Licencazonosító",
  licenseProduct: "Licencelt készítmény",
  supplementaryInformation: "Kiegészítő információ",
  dosageForm: "Adagolási forma",
  pharmacyGLN: "Gógyszertár GLN kódja",
  createLicensedMedication: "Licencelt gyógyszer készítése",
  oneYearInterval: "Egy évnyi intervallum lehet.",
  chooseAPharmacy: "Válassz egy gyógyszertárat!",
  pleaseChoosePackages: "Adjon a recepthez legalább egy csomagot.",
  pleaseFillInstructions: "Kérem, töltse ki az utasításokat.",
  tooManyCharactersEnteredToInstructions: "Túl sok karakter került beírásra az instrukciókba.",
  tooManyCharactersEntered: "Túl sok karakter került beírásra.",
  withdraw: "Visszavonás",
  animalCarerInformed: "Tulajdonos tájékoztatva",
  onlyTwoFieldsAllowed: "Csak két mező kitöltése megengedett.",
  commentToPharmacist: "Megjegyzés",
  mandatoryIfLicenseIdProvided: "Kötelező, ha az azonosító adott.",
  groupCode: "Csoportazonosító",
  searchCommodity: "Kereskedelmi termék keresése",
  businessCompany: "Gyártó",
  atcCode: "ATC kód",
  productType: "Terméktípus",
  marketed: "Piaci elérhetőség",
  unMarketed: "Nem elérhető",
  drugClass: "Gyógyszerosztály",
  nplId: "NPL azonosító",
  nplPackId: "NPL csomagazonosító",
  nvn: "Nvn (VARA)",
  allProduct: "Minden termék",
  allGroup: "Minden kategória",
  quantityLimit: "Mennyiség",
  prescriptionDrug: "Vényköteles",
  lactose: "laktóz",
  latex: "latex",
  showOnlyMarketed: "Piacon elérhető termékek mutatása",
  showOnlyUnMarketed: "Piacon nem elérhető termékek mutatása",
  withdrawn: "Visszavonva",
  chooseASpecificPharmacy: "Válasszon gyógyszertárat",
  searchLicenseProduct: "Licencelt termék keresése",
  searchApprovedProducts: "Engedélyezett termékek",
  searchNotApprovedProducts: "Nem engedélyezett termékek",
  receiverPharmacy: "Fogadó gyógyszertár",
  none: "Egyik sem",
  cancelledPrescriptions: "Visszavont receptek",
  prescriptionsWithWarnings: "Figyelmeztetéses receptek",
  failedPrescriptions: "Hibás receptek",
  cancelledBy: "Visszavonta",
  requestedBy: "Kérvényezte",
  preview: "Előnézet",
  totalAmount: "Teljes mennyiség",
  draft: "piszkozat",
  dosageInfo:
    "Az adagolási mezők használata opcionális, viszont legalább egy kitöltése kötelező. Az előnézetben megtekintheti a végleges instrukciót.",
  defaultFeeToolTip: "Alapértelmezett receptszolgáltatási díj {0} SEK, mely a rendelő beállításai között módosítható.",
  successfulPrescription: "A recept beküldése sikeres volt.",
  warningPrescription: "A recept beküldése figyelmeztetésekkel sikeres volt.",
  failedPrescription: "A recept beküldése sikertelen volt.",
  cancellationDetails: "Visszavonás részletei",
  statusOfCancellation: "Visszavonás állapota (válasz és kód)",
  cancellationId: "Lemondási azonosító",
  causeOfCancellation: "Visszavonás oka",
  partnerPharmacies: "Partner gyógyszertárak",
  acceptedPrescriptions: "Sikeres receptek",
  accepted: "Elfogadva",
  notAccepted: "Elutasítva",
  addNewName: "Új név",
  pinWarning: "PIN kód nincs beállítva. Recept kiállítás előtt a profil beállításokban hozzon létre egy új PIN kódot.",
  treatmentPurpose: "Kezelés célja",
  validUntil: "Érvényesség",
  otherSettings: "Egyéb beállítások",
  validUntilToolTip:
    "Antimikrobális készítmény: a kiállítástól számított 5 napig érvényes. Papír és elektronikus recept: kiállítástól számított egy évig érvényes.",
  notAntimicrobial: "Nem antimikrobiális",
  therapyShortHelpText: "beteg állatok kezelése",
  prophylaxisShortHelpText: "megelőzés",
  metaphylaxisShortHelpText: "fertőzés terjedésének megelőzése állatoknál",
  prophylaxisLongHelpText:
    "gyógyszer kiállítása állatnak vagy állatoknak a betegség klinikai tüneteinek megjelenése előtt, a kialakulásának megelőzésére vagy a fertőzés megállítására.",
  metaphylaxisLongHelpText:
    "gyógyszer kiállítása állatnak vagy állatoknak a betegség klinikai tüneteinek megjelenése után, a beteg állatok kezelésére és a további, - a ferőzött egyedekkel kapcsolatba került - állatok megfertődőzésének megelőzésére.",
  forFurther: "folytatva",
  everyOtherWeek: "Every other week",
  everyOtherDay: "Every other day",
  choose: "Használ",
  backToSearch: "Vissza a kereséshez",
  productAddedSuccessfully: "Sikeresen hozzáadta {0}-t a recepthez.",

  // Tasks
  task: "Teendő",
  tasks: "Teendők",
  newTask: "Új teendő",
  editTask: "Teendő szerkesztése",
  deleteTask: "Teendő törlése",
  complete: "Teljesített",
  completed: "Teljesített",
  onGoing: "Aktív",
  employee: "Munkatárs",
  petOrOwner: "Állat vagy gazda",
  areYouSureDeleteTask: "Biztosan törölni szeretné a teendőt?",
  seeAllTasks: "Összes teendő",
  taskCreatedSuccessfully: "A teendőt sikeresen létrehoztuk.",
  taskSavedSuccessfully: "A teendőt sikeresen elmentettük.",
  taskDeletedSuccessfully: "A teendőt sikeresen töröltük.",
  addToTask: "Hozzáadás",
  saveAndCreate: "Mentés és létrehozás",

  // ModifyClinic
  basicInfo: "Alapadatok",
  contactInfo: "Kapcsolat",
  bankAndBilling: "Bank és számlázás",
  position: "Munkakör",
  managers: "Menedzserek",
  vets: "Állatorvosok",
  assistants: "Asszisztensek",
  authorizedAssistants: "Autorizált asszisztensek",
  receptionists: "Recepciósok",
  employeeAlreadyAdded: "A dolgozó már a rendelőben dolgozik egy másik beosztásban.",
  modifyClinic: "Rendelő módosítása",
  inventory: "Raktár",
  calendar: "Naptár",
  clinicStatistics: "Statisztika",
  reservationTypes: "Foglalás típusok",
  notifications: "Értesítések",
  smsWarning: "Az SMS értesítésekért külön díjat számítunk fel.",
  sendRemindersVia: "Időpontemlékeztetők küldése {0} az állattulajdonosoknak",
  sendRemindersViaEmail: "emailben",
  sendRemindersViaSms: "SMS-ben",
  inventoryHandling: "Raktárkezelés",
  trackInventoryStock: "Raktárkészlet követése",
  inventoryTrackingDisableText:
    "Ez a művelet kinulláza az összes raktáron lévő tétel mennyiségét. A mennyiségek eltűnnek, de az árazás és a kezelések továbbra is megmaradnak.",
  decline: "Elutasít",
  accept: "Elfogad",
  inventoryTrackingEnabled: "Raktárkészlet követése bekapcsolva",
  inventoryTrackingDisabled: "Raktárkészlet követése kikapcsolva",
  clinicHasNoReservationTypes: "A rendelőnek még nincsnenek időpontfoglalási típusai.",
  affiliatedSwedishPharmacies: "Partner gyógyszertárak",
  addPharmacy: "Új gyógyszertár",
  order: "Sorrend",
  basicInfoTooltip: "Alap rendelő beállítások. Rendelő nevének módosítása.",
  basicInfoContactTooltip: "Alap rendelő beállítások. A rendelő elérhetőségeinek módosítása.",
  collaboratorsToolTip:
    "Rendelő munkatársainak beállításai. Asszisztensek, állatorvosok, recepciósok, és menedzserek felvétele, törlése.",
  reservationTypesToolTip:
    "Rendelő foglalás fajtái, melyek segítségével foglalhatnak időpontokat a rendelő munkatársai és a gazdák, naptáron keresztül.",
  feesToolTip:
    "Rendelő általános díjai. Itt lehet beállítani az alapértelmezett árakat, de később azok minden munkafolyamatban testreszabhatók.",
  prescriptionFeeToolTip:
    "A receptdíj használatához ki kell választani egy Bankgiro vagy Plusgiro fiókot, melyet a rendelő beállításainál lehet megadni.",
  notificationToolTip:
    "Emlékeztető beállítás gazdák számára. A rendszer e-mail vagy SMS emlékeztetőt küld foglalások előtt.",
  inventoryToolTip:
    "Rendelő raktárbeállításai. Raktár követés funkció bekapcsolásával a kezelések automatikusan levonják az elhasznált eszközöket a készletből.",
  clinicPharmacyTooltip: "Receptdíj beszedhető ezekben a gyógyszertárakban, kölcsönös megállapodás alapján.",
  deletedProfile: "Törölt profil",
  notificationEmailMessage: "Egyedi üzenet",
  notificationOnReservationCreate: "Új foglalás létrehozásakor {0} küldése a gazdának",
  notificationOnReservationCreateEmail: "email",
  notificationOnReservationCancel: "Foglalás törlésekor {0} küldése a gazdának",
  notificationOnReservationCancelSms: "SMS",
  notificationOnReservationReschedule: "Foglalás módosításakor {0} küldése a gazdának",
  notificationOnReservationRescheduleSms: "SMS",
  calendarSettings: "Naptár beállítások",
  calendarSettingsToolTip: "Naptár kezdő és záró időpontjának beállítása. Alapbeállítás: 08:00–18:00.",
  confirmEmployeeInvitation: "Biztosan szeretne meghívót küldeni a {0} címre?",
  confirmEmployeeRequestDeletion: "Biztosan szeretné visszavonni {0} meghívását?",
  inviteEmployee: "Munkatárs meghívása",
  areYouSureToRemoveEmployee: "Biztosan el szeretné távolítani a munkatársat ebből a pozícióból?",
  removeEmployee: "Munkatárs eltávolítása",
  pricingExamples: "Árazási példák",

  // NavSiteManager
  SITE_MANAGER_SETTINGS: "Beállítások",
  BILLING: "Számlázás",
  VET_DOCUMENTS: "Orvosi dokumentumok",
  INSURANCE: "Biztosítás",
  USERS: "Felhasználók",
  FEEDBACKS: "Visszajelzések",
  CLINICS: "Klinikák",
  SPECIES: "Fajok",
  ANALYTICS: "Analitika",
  VIDEOCHAT_MONITOR: "Videochat monitor",
  MIMIR_TEST: "Mimir teszt",

  // Species
  isProducingAnimal: "Termelő állat",
  fromClinic: "Ajánló rendelő",
  swedishPrescriptionCategory: "Svéd receptkategória",
  petVetDataSpeciesCategory: "PetVetData kategória",
  addSpecies: "Új faj",
  latinName: "Latin megnevezés",

  // Usage statistics
  statisticsTitle: "Statisztika",
  statisticsAndPayment: "Statisztika és fizetés",
  generalData: "Általános adatok",
  chooseAMonth: "Hónap kiválasztása",
  chooseMonth: "Válassz hónapot!",
  priceOfUsedItems: "Felhasznált segédeszközök összköltsége",
  priceOfAppliedFees: "Szolgáltatások költsége",
  statisticsErrorMsg: "Nincs elérhető statisztikai adat.",
  inventoryStockUsageFee: "Összes raktárhasználati díj",
  sumFeeAtMoment: "Aktuális költségek a hónapban",
  forecastFeeSum: "További prognosztizált költségek a hónapban",
  summaryOfFees: "Teljes összeg",
  noPrevDataFound: "Nincs elérhető adat",
  monthlySubscriptionHistory: "Havi előfizetési előtörténet",
  subscriptionPackage: "Előfizetéscsomag",
  actual: "Aktuális",
  currentlyActive: "Jelenleg aktív",
  feeName: "Költség neve",
  count: "Darabszám",
  unitPrice: "Egységár",
  subtotal: "Részösszeg",
  usageStatistics: "Statisztika",
  clinicCosts: "Rendelő költségei",
  organizationCosts: "Szervezet költségei",
  analyticsEventType: "Esemény típusa",
  user: "Felhasználó",
  activityLogs: "Tevékenységnapló",
  ownedClinics: "Saját klinikák",
  workplaces: "Munkahelyek",
  clinicsVisited: "rendelő meglátogatva",
  lastActivity: "Utolsó tevékenység",
  lastCharge: "Utolsó fizettetés",
  overviewActivity: "Tevékenység",
  overviewLast24hours: "Elmúlt 24 óra",
  overviewLast7days: "Elmúlt 7 nap",
  overviewLast30days: "Elmúlt 30 nap",
  overviewTotalEvents: "Összes esemény",
  overviewActiveUsers: "Aktív felhasználók",
  overviewActiveClinics: "Aktív klinikák",
  overviewNewUsers: "Új felhasználók",
  overviewNewClinics: "Új klinikák",
  softwareUsage: "Szoftverhasználat",
  inventoryStockValue: "Raktárkészlet",
  inventoryStockTotalAcquisitionNetPrice: "Teljes bevételezett érték (nettó)",
  inventoryStockTotalAcquisitionGrossPrice: "Teljes bevételezett érték (bruttó)",
  inventoryStockTotalSaleNetPrice: "Teljes várható eladási érték (nettó)",
  inventoryStockTotalSaleGrossPrice: "Teljes várható eladási érték (bruttó)",
  downloadInventoryStockValues: "Árösszesítő letöltése",
  printInventoryStockValues: "Árösszesítő nyomtatása",
  sortByLabel: "Rendezés",
  sortByName: "Név szerint",
  sortByRegistrationDate: "Regisztráci dátuma szerint",
  sortByLastActivity: "Utolsó tevékenység szerint",
  sortByLastCharge: "Utolsó fizettetés",

  // Organization settings
  modifyOrganization: "Szervezet módosítása",
  editOrganizationNamePlaceholder: "A szervezet neve",
  editBusinessNamePlaceholder: "A szervezetet működtető vállalkozás neve",
  editVATNumberPlaceholder: "A szervezet adószáma",
  editRegistrationNumberPlaceholder: "A szervezet regisztrációs száma",
  clinics: "Rendelők",
  createNewClinic: "Új rendelő létrehozása",
  createNewOrganization: "Új szervezet létrehozása",
  manager: "Menedzser",
  creditCard: "Bankkártya adatai",
  creditCardNumber: "Bankkártya száma",
  fortnoxInvoiceSystem: "Fortnox számlázórendszer",
  state: "Állapot",
  integrated: "Összekapcsolva",
  notIntegrated: "Nincs összekapcsolva",
  authenticationNeeded: "Hitelesítés szükséges",
  authenticate: "Hitelesítés",
  fortnoxIntegration: "Fortnox összekapcsolás",
  addIntegration: "Összekapcsolás",
  fortnoxIntegrationSuccess: "Sikeresen összekapcsolódott a Fortnox rendszerével.",
  disableFortnoxConfirmation: "Biztosan törölni szeretné a Fortnox kapcsolatot?",
  fortnoxRedirect:
    "Át fogjuk irányítani a Fortnox weboldalára. Kérjük, kövesse a megadott lépéseket az integráció befejezéséhez.",
  editData: "Adatok szerkesztése",
  turnOff: "Kikapcsolás",
  fortnoxIntegrationCostWarning: "Az összekapcsolás aktiválása és igénybevétele kezelési költségekkel jár.",
  invalidData: "Érvénytelen adatok",
  settingsFailed: "Sikertelen beállítás",
  stripeIntegration: "Stripe összekapcsolás",
  stripeIntegrationCostWarning: "Az öszekapcsolás aktiválása és igénybevétele kezelési költségekkel jár.",
  szamlazzIntegration: "Szamlazz.hu összekapcsolás",
  szamlazzIntegrationCostWarning: "Az öszekapcsolás aktiválása és igénybevétele kezelési költségekkel jár.",
  szamlazzApiKey: "Számla Agent kulcs",
  publicKey: "Nyilvános kulcs",
  privateKey: "Privát kulcs",
  bankAndPlusGiroAccount: "Bankgirot és Plusgirot fiókok",
  bankgirot: "Bankgirot",
  plusgirot: "Plusgirot",
  prescriptionFee: "Receptfelírási díj",
  videoConsultationFee: "Videókonzultáció díja",
  basicInfoOrgToolTip:
    "A cég általános beállításai. A név egy tetszőlegesen választható megjelenített név, a cégnév a jogi személy hivatalos neve.",
  basicInfoOrganizationNameToolTip: "Egy tetszőlegesen választható, csak a GlobalVet alkalmazásban használt név.",
  basicInfoBusinessNameToolTip: "A vállalkozás hivatalos neve.",
  basicInfoContactOrgToolTip:
    "A cég hivatalos elérhetőségeinek beállításai. Elsőként az elődleges elérhetőségeket használja a rendszer.",
  managersOrgToolTip: "A cég menedzserei, akik a cég minden adatát módosíthatják.",
  giroOrgToolTip:
    "Bankgiro vagy Plusgiro fiók szükséges a svéd receptbeküldéshez, abban az esetben amikor a receptet egy partnergyógyszertárban fizeti ki az ügyfél.",
  creditCardOrgToolTip:
    "A cég bankkártyaadatai. A GlobalVET szolgáltatásainak díjait erre a kártyára terheli majd a rendszer.",
  stripeOrgToolTip:
    "A rendszer támogatja a Stripe használatát az online fizetésekhez. Ha a cég rendelkezik Stripe fiókkal, itt összekötheti az alkalmazással.",
  fortnoxToolTip:
    "A rendszer támogatja a Fortnox használatát a számlázáshoz. Ha a cég rendelkezik Fortnox fiókkal, itt összekötheti az alkalmazással.",
  szamlazzTooltip:
    "A rendszer támogatja a Szamlazz.hu használatát a számlázáshoz. Ha a cég rendelkezik Szamlazz.hu fiókkal, itt összekötheti az alkalmazással.",
  invoicingInfo:
    "A rendszer támogatja a {0} és a {1} használatát. Ha Ön rendelkezik valamelyik számlázó programmal, itt összekötheti az alkalmazással.",
  statisticsToolTip: "A rendszer használatáról készült statisztika és fizetési előzmények.",
  treatmentToolTip:
    "Az itt felvett kezeléseket használhatja a rendelő a kórlapkitöltések során. Egy kezelés hozzárendelhető egy konkrét fajhoz, vagy általánosan is meghatározható.",
  addFee: "Díj hozzáadása",
  createNewServiceFee: "Új szolgáltatási díj létrehozása",
  addPaymentMethod: "Fizetési mód hozzáadása",
  supportedPaymentMethods: "Támogatott fizetési módok",
  noPaymentMethods: "A klinikának nincs támogatott fizetési módja még.",
  createCodeInFortnox: "Kód létrehozása a Fortnoxban is",
  officialLanguage: "Hivatalos nyelv",
  syncWithFortnox: "Fortnox szinkronizálás",
  roundingSettings: "Kerekítés és áfaszámolás",
  roundingSettingsTooltip:
    "Ha GlobalVethez kapcsolt külső számlázót (Fortnox vagy Számlázz.hu) is használ, akkor kérjük, győződjön meg róla, hogy ugyanazokat a kerekítési szabályokat állítja be itt, mint amiket a számlázó is használ!",
  roundingStrategyItem: "Számlatétel kerekítése",
  roundingStrategyTotal: "Számlavégösszeg kerekítése",
  vatCalculationStrategy: "ÁFA számítás",

  // OwnerClinicListPage
  cannotRetriveOrganizationData: "Nem sikerült betölteni a szervezet adatait.",
  cannotRetrivePetData: "Nem sikerült betölteni az állat adatait.",
  clinicListByOrganization: "Rendelők listája",
  reserveAppointment: "Időpont foglalása",
  organizations: "Szervezetek",
  chooseClinic: "Válassz rendelőt!",
  chooseReservationType: "Válassz foglalási típust!",
  choosePet: "Válassz állatot!",
  chooseAPet: "Válassz egy állatot!",
  next: "Tovább",
  previous: "Vissza",
  unselected: "Nincs kiválasztva",

  // OwnerCalendarPage
  reason: "Indok",
  writeReason: "Írja le az indokot...",

  // OwnerInvoicePage
  invoiceToPay: "Befizetendő számlák",
  creationOfInvoice: "Számla kelte",
  invoices: "Számlák",
  pdf: "PDF",
  paid: "Fizetve",
  infoOnlinePaymentDisabled: "Ennél a rendelőnél nem lehet online számlát befizetni.",
  noInvoicesToPay: "Nincsenek befizetendő számlák.",
  noInvoices: "Nincsenek számlák.",

  // WorkerCalendarPage
  back: "Vissza",
  chosenDate: "Választott dátum",
  chooseADoctor: "Választott állatorvos",
  chooseDoctor: "Válassz állatorvost vagy asszisztenst!",
  description: "Leírás",
  writeSymptoms: "Írd le a tüneteket...",
  reserve: "Foglalás",
  reservationError: "Erre az időpontra nem lehet foglalni.",
  reservationInProgress: "Foglalás folyamatban",
  browseNewTimeSlot: "Új időpont keresése",
  newReservation: "Új időpont foglalása",
  deletedItsProfile: " törölte a profilját.",
  collaborator: "Munkatárs",
  createShiftFor: "Munkatárs",
  reservationDetails: "Foglalás részletei",
  reject: "Elutasít",
  showReservations: "Foglalások mutatása",
  showShifts: "Műszakok mutatása",
  shifts: "Műszakok",
  shift: "Műszak",
  modifyShiftFor: "{0} műszakjának módosítása",
  reservations: "Foglalások",
  listView: "Listanézet",
  list: "lista",
  doctorView: "Orvosi nézet",
  reScheduleAppointment: "Foglalás áthelyezése",
  reScheduleToolTip: "Keressen a naptárban egy új időpontot.",
  reSchedule: "Áthelyezés",
  confirmReSchedule: "Áthelyezés megerősítése",
  startLaterThanEnd: "Végidőpont nem lehet korábban a kezdetnél.",

  // Symptoms
  symptom: "Tünet",
  symptoms: "Tünetek",
  searchOrCreateSymptom: "Tünet keresése vagy új hozzáadása",

  // Profile
  savedSuccessfully: "Sikeres mentés",
  passwordChangedSuccessfully: "Sikeres jelszóváltás",
  changeMyPassword: "Jelszó megváltoztatása",
  setDefaultLanguage: "Alapértelmezett nyelv beállítása",
  notSpecified: "Nincs kiválasztva",
  contacts: "Kapcsolat",
  language: "Nyelv",
  upload: "Feltöltés",
  security: "Biztonság",
  linkedAccounts: "Összekapcsolt fiókok",
  googleAccount: "Google fiók",
  facebookAccount: "Facebook fiók",
  noLinkedAccounts: "Nincs összekapcsolt fiók.",
  accountLinkedSuccessfully: "A fiók összekapcsolása sikeresen megtörtént.",
  idNumber: "Személyi szám",
  pinCodeMustBeConfirmed: "A PIN kód használata előtt meg kell erősíteni azt.",
  codeIsSentToYourMobile: "A megerősítő kódot elküldtük az elsődlegesen használt mobiltelefonszámra.",
  addNewPin: "Új PIN kód hozzáadása",
  verifyPin: "PIN kód megerősítése",
  userHasPinCode: "Önnek már van beállítva PIN kód.",
  profilePictureIsPublic: "A profilkép minden felhasználó számára nyilvános.",
  deleteProfile: "Profil törlése",
  deleteProfileWarning:
    "A kért művelet nem visszavonható, a személyes adatok törlésre kerülnek a rendszerből. Kérjük, vegye figyelembe, hogy azoknak a klinikáknak, melyek korábban szolgáltatást nyújtottak Önnek, továbbra is lesz hozzáférésük bizonyos adatokhoz a számlázással és az állatok követhetőségével kapcsolatban.",
  deleteProfileWarningWorker:
    "A korábbi műveletek, amiket rendelői dolgozóként végrehajtott, a rendelő többi dolgozója számára láthatók maradnak.",
  deleteProfileCredentials: "Kérjük, adja meg a belépési jelszavát a törlés megerősítéséhez:",
  deleteContactInformation: "Elérhetőség törlése",
  areYouSureDeleteContactInformation: "Biztosan törölni szeretné elérhetőségét?",
  profileBasicInfoToolTip:
    "Alap profil beállítások kezelése. A személyi szám lakcímhez kötött, változtatása új cím felvételével lehetséges.",
  profileContactToolTip:
    "E-mailek, címek és telefonszámok szerkesztése. Az elsődlegesen kiválasztott elérhetősége lesz a rendszerben használva.",
  profileVetRegNumberToolTip: "Hivatalos nemzeti állatorvosi regisztrációs számok kezelése.",
  vetRegNumberInfo: "Receptkiállításhoz szükséges az állatorvosi azonosító feltöltése.",
  vetRegNumbersEmpty: "Önnek jelenleg nincs megadva állatorvosi regisztrációs száma.",
  vetRegNumberDeleteConfirmation: "Biztosan ki szeretné törölni ezt az állatorvosi regisztrációs számot?",
  changesSavedSuccessfully: "A változtatások sikeresen el lettek mentve.",

  // ResetPassword
  PasswordRecoveryLinkNotValid: "A jelszóhelyreállítási link nem érvényes.",
  resetPassword: "Jelszó viszaállítása",
  resetPasswordEmailInfo:
    "Írja be a regisztrációhoz használt e-mail címét. A megadott e-mail címre küldjük a jelszóemlékeztetőt.",
  resetPasswordMobileInfo: "Írja be a regisztrációhoz használt telefonszámát.",

  // SearchResult
  ownerName: "Tulajdonos neve",
  addNewAppointment: "Új időpont hozzáadása",
  newAppointment: "Új időpont",
  newMedicalRecord: "Új kórlap",
  addNewMedicalRecord: "Új kórlap hozzáadása",
  periodDoesNotFitIntoShift: "A foglalás nem fér bele a választott műszakba.",
  pages: "oldal",
  openLastMedicalRecord: "Utolsó kórlap megnyitása",
  petHasNoMedicalRecords: "Ennek az állatnak még nincsenek kórlapjai.",
  total: "Összesen",
  results: "találat",

  // PhoneConfirmation
  phoneConfirmation: "Telefonszám megerősítése",
  verifyYourPhone: "A telefonszám megerősítése",
  confirmationCode: "Megerősítő kód",
  verificationCode: "Ellenőrző kód",
  confirmationLinkNotValid: "A megadott link érvénytelen.",
  invalidVerificationCode: "Érvénytelen ellenőrző kód, próbálja újra.",
  confirmationCodeMustBeSixCharacters: "Az ellenőrző kód pontosan 6 karakterből áll.",
  phoneConfirmationSuccess: "Telefonszám sikeresen megerősítve.",
  resendVerificationCode: "Új ellenőrző kódot kérek",
  phoneCodeSent: "Elküldtük az ellenőrző kódot a következő számra: ",

  // TreatmentPage
  dontHavePermissionToCreateTreatments: "NIncs jogosultsága kezelés létrehozására.",
  worngNameOrPrice: "Helytelen név vagy ár.",
  showAll: "Mindent mutat",
  useFilter: "Szűrő használata",
  chooseTheSpecies: "Faj kiválasztása",
  deleteTreatment: "Kezelés törlése",
  editTreatment: "Kezelés szerkesztése",
  nameSuggestionToolTip: "Itt a többi organizácó kezeléseinek elnevezéseiből lehet választani.",
  generateIntoMedicalRecordToolTip: "Ez a leírás a kórlapba is be fog kerülni.",
  backToTreatments: "Vissza a kezelésekhez",

  // WorkerClinicPage
  thWeek: "{0}. hét",
  noShiftOnThisDay: "Erre a napra nincs műszak rögzítve.",
  owner: "Tulajdonos",
  consultationType: "Konzultáció típusa",
  time: "Időpont",
  action: "Művelet",
  saveAsPDF: "Mentés PDF-ként",
  medicalRecord: "Kórlap",
  costCalculation: "Költség összegzés",

  // Add AddressOwnershipForm
  addAddress: "Cím hozzáadása",
  city: "Város",
  zip: "Irányítószám",
  postalCode: "Irányítószám",
  street: "Utca",
  county: "Megye",
  building: "Épület",
  addressLine1: "Utcanév és házszám",
  addressLine2: "Épület, emelet, lakás",
  setPrimaryAddress: "Elsődleges cím beállítása",
  deleteAddress: "Cím törlése",
  deleteAddressConfirmation: "Biztosan ki szeretnéd törölni ezt a címet?",
  primaryAddressPromotionTextPart1: "Szeretnéd beállítani ",
  primaryAddressPromotionTextPart2: " címet elsődlegesnek?",
  primaryEmailPromotionTextPart1: "Szeretnéd beállítani ",
  primaryEmailPromotionTextPart2: " email címet elsődlegesnek?",
  primaryPhonePromotionTextPart1: "Szeretnéd beállítani ",
  primaryPhonePromotionTextPart2: " telefonszámot elsődlegesnek?",
  setAsPrimary: "Beállítás elsődlegesnek",
  setPrimaryEmail: "Elsődleges email cím beállítása",
  deleteEmail: "Email cím törlése",
  deleteEmailConfirmation: "Biztosan ki szeretnéd törölni ezt az email címet?",
  setPrimaryPhone: "Elsődleges telefonszám beállítása",
  deletePhoneNumber: "Telefonszám törlése",
  deletePhoneNumberConfirmation: "Biztosan ki szeretnéd törölni ezt a telefonszámot?",
  timeZoneRequired: "Az időzóna megadása kötelező.",

  // UserAddressForm
  newAddressDetails: "Új cím megadása",
  newAddressCheck: "Új cím ellenőrzése",
  checkSuccessful: "Sikeres címellenőrzés!",
  found: "Talált",
  chosen: "Kiválasztott",
  timeZone: "Időzóna",

  // AddEmailOwnershipForm
  addEmail: "Email hozzáadása",
  email: "Email",
  emailExample: "pelda@vallalat.com",
  emailExampleName: "nev@company.com",
  yourEmailv1: "Írd be, és lépj tovább.",
  yourEmail: "Email címed",

  // Switch
  on: "Be",
  off: "Ki",

  // Modal
  closeModal: "Ablak bezárása",

  // Select
  pleaseChoose: "Kérünk válassz!",

  // AddPhoneOwnershipForm
  addPhoneNumber: "Telefonszám hozzáadása",
  phone: "Telefonszám",
  emailRequiredForPhone: "Legalább egy megerősített email cím szükséges a telefonszám hozzáadásához.",

  // Ownerships
  addresses: "Címek",
  availableAddresses: "Elérhető címek",
  address: "Cím",
  yourAddress: "Az ön címe",
  location: "Helyszín",
  emails: "Emailek",
  phoneNumbers: "Telefonszámok",
  phoneNumber: "Telefonszám",
  phones: "Telefonszámok",
  availablePhones: "Elérhető telefonszámok",
  emailNotConfirmedYet: "Email cím még nincs megerősítve.",
  emailConfirmationSuccess: "Email cím sikeresen megerősítve.",
  atLeastOneEmailRequired: "Legalább egy email cím megadása szükséges.",
  primary: "Elsődleges",
  private: "Privát",
  public: "Nyilvános",
  notPublic: "Nem nyilvános",
  contactType: "Típus",
  vat: "Adószám",
  vatNumber: "Adószám",
  vatAsTax: "ÁFA",
  phoneType: "Telefon típusa",
  phoneNotConfirmedYet: "A telefonszám még nincs megerősítve.",
  verificationCodeSentTo: "Elküldtük az ellenörző kódot a következő számra: {0}.",
  verificationError: "Hibás megerősítés",
  primaryContactNotDeletable:
    "Az elsődleges elérhetőséget nem tudod törölni. Előbb adj meg egy újat, állítsd be elsődlegesnek, és csak ezután töröld a régi elérhetőséget.",

  // AddReservationTypeForm
  addReservationType: "Foglalási típus hozzáadása",
  createNewReservationType: "Új foglalási típus létrehozása",
  duration: "Időtartam (perc)",
  durationMustBePositive: "Az időtartamnak pozitív egész számnak kell lennie.",
  isReservableByOwnersQuestion: "Állat tulajdonosai is foglalhatják ezt a típust?",
  isReservableByOwners: "Online foglalás engedélyezése",
  isVideoConsultationAllowedQuestion: "Online videókonzultációként is foglalható ez a típus?",
  isVideoConsultationAllowed: "Videókonzultáció engedélyezése",
  onlineReservationIsNotAvailable: "Online foglalás nem elérhető ezen a klinikán.",

  // EditReservationTypeForm
  editReservationType: "Foglalási típus módosítása",

  // AddTreatmentForm
  addTreatment: "Kezelés hozzáadása",
  createNewTreatment: "Új kezelés létrehozása",
  treatmentName: "Kezelés neve",
  treatmentPrice: "Kezelés ára",
  chooseASpecies: "Válassz egy fajt",
  treatmentNameMustNotBeEmpty: "A kezelés nevét kötelező kitölteni.",
  addTreatmentSuccess: "Kezeléshez sikeresen hozzáadva.",
  workCost: "Munkaköltség",
  basePrice: "Alapár",

  // AddUserForm
  addNew: "Hozzáad",
  addNewManager: "Menedzser hozzáadása",

  // BillingSection
  billing: "Számlázás",
  item: "Tétel",
  quantity: "Mennyiség",
  extraItems: "Extra tételek",
  extraItemsAndFees: "Extra tételek és díjak",
  addExtraItem: "Extra tétel hozzáadása",
  add: "Hozzáad",
  sum: "Végösszeg",
  taxNumber: "Adószám",
  sellItems: "Termékek eladása",
  accountingCode: "Könyvelési kód",
  accountingCodes: "Könyvelési kódok",
  chargeClinic: "Klinika fizettetése",
  retryClinicCharge: "Újrapróbálkozás",
  cancelClinicCharge: "Visszavonás",
  clinicChargeDetails: "Fizettetés részletei",
  customAccountingCodes: "Egyedi könyvelési kódok",
  accountingCodeSettingsInfo:
    "Az alapértelmezett könyvelési kódokon felül van lehetőség egyedi kódok felvételére is. Amennyiben egy kód azonos az alapértelmezettel, az egyéni változat fog megjelenni.",
  addAccountingCode: "Új könyvelési kód hozzáadása",
  customBillingAddress: "Egyedi számlázási cím",

  // BanCardForm
  cardData: "Kártya adatai",

  // CategoryList
  categories: "Kategóriák",
  createNewCat: "Új kategória létrehozása",
  Vaccines: "Vakcinák",
  Medicines: "Gyógyszerek",

  // ChronicDiseasesModal
  alreadyRegisteredDiseases: "Eddig regisztrált krónikus betegségek",
  diseaseName: "Betegség neve",
  certified: "Hitelesítve",
  notCertified: "Nincs hitelesítve",
  confirmMessage: "A hitelesítés csak akkor teljesül, ha a betegséget egy állatorvos megerősíti a kórlapon.",
  certificationDate: "Hitelesítés dátuma",
  addNewChronicDisease: "Új krónikus betegség hozzáadása",

  // DeleteReservation
  AreYouSureDeleteAppointment: "Biztos, hogy lemondja az időpontot?",
  whyDoYouWantToRejectAppointment: "Kérem adja meg, hogy miért utasítja vissza ezt az időpontot.",
  confirm: "Megerősít",
  cancelAppointment: "Időpont lemondása",
  rejectAppointment: "Időpont elutasítása",
  rejectError: "Időpont törlése nem lehetséges.",
  cancelAppointmentSuccess: "Sikeresen lemondta az időpontot.",
  cancelAppointmentError: "Az időpont lemondása már nem lehetséges. Kérjük vedd fel a kapcsolatot a rendelővel.",

  // InventoryNavBar.tsx
  bracnhesInventory: "{0} / Raktár",
  home: "Főoldal",
  inventoryStatus: "Raktár állapota",

  // Treatments
  comment: "Megjegyzés",
  items: "Tételek",
  remove: "Eltávolítás",
  saveAsNew: "Mentés másként",
  use: "Felhasznál",
  treatmentDescription: "Kezelés leírása",
  advices: "Tanácsok az állat gazdájának",
  suggestedMedicines: "Javasolt gyógyszerek",
  complications: "Komplikációk",

  // Inventory
  searchWithDots: "Keresés...",
  new: "Új",

  // OwnerCalendar
  toggleWeekends: "Hétvégék megjelenítése",
  prevWeek: "Előző",
  nextWeek: "Következő",
  appointment: "Időpont",
  createUnregisteredPet: "Regisztráció",
  theOwnerWillNotSee: "A gazda ezt nem fogja látni.",
  personalId: "Személyazonosító szám",
  personalIdFormatPlaceholder: "yyyymmddpppp",
  invalidFormat: "Érvénytelen formátum, elvárt formátum: {0}",
  iDontHavePersonalIdInThisCountry: "Nincs személyi azonosítóm az adott országban",
  doesntHavePersonalIdInThisCountry: "Nincs személyi azonosítója az adott országban",
  checkClinicRegistrationsNotificationMsg: "Úgy tűnik, hogy Ön már járt állatorvosi rendelőben, mielőtt regisztrált.",
  resolveClinicRegsBtnTitle: "Ellenőrzés",
  pendingClinicRegistrations: "Regisztrációk megerősítése",
  createAsNewPet: "Új állatként létrehoz",
  claimAsMe: "Elfogad",
  itWasntMe: "Nem én voltam",
  thereAreNoPendingClinicRegistrations: "Nincsenek megerősítésre váró regisztrációk.",
  iAcceptThatOrganizationWillReceiveMyData:
    "Elfogadom, hogy a szervezet hozzáférést kap a személyes adataimhoz és az állat kórelőzményeihez a kezelés elősegítésének érdekében.",
  noAvailableShiftsForThisReservationType: "Ehhez a foglalástípushoz nincsenek szabad időpontok.",
  pleaseChooseService: "Kérünk válassz egy szolgáltatást.",

  // Video consultation
  videoConsultation: "Videókonzultáció",
  videoConsultations: "Videókonzultációk",
  globalVetVideoConsultation: "GlobalVET videókonzultáció",
  usersInTheRoom: "Már a szobában lévő felhasználók:",
  enableMicrophone: "Mikrofon bekapcsolása",
  enableCamera: "Kamera bekapcsolása",
  noCamera: "Nincs kamera",
  noMicrophoneDetected:
    "A mikrofonja nem észlelhető. Kérjük győződjön meg róla, hogy a mikrofon megfelelően van csatlakoztatva, ha szeretne beszélni.",
  microphoneAccessDenied: "Mikrofon hozzáférés megtagadva! Kattintson ide további információkért.",
  microphoneAccessDeniedByError: "Mikrofon hozzáférés ideiglenesen megtagadva! Kattintson ide további információkért.",
  microphoneWorks: "A mikrofonjának a várt módon kell működnie.",
  noWebcamDetected:
    "A webkamerája nem észlelhető. Kérjük győződjön meg róla, hogy a webkamera megfelelően van csatlakoztatva, ha szeretné, hogy mások is lássák.",
  webcamAccessDenied: "Webkamera hozzáférés megtagadva! Kattintson ide további információkért.",
  webcamAccessDeniedByError: "Webkamera hozzáférés ideiglenesen megtagadva! Kattintson ide további információkért.",
  webcamWorks: "A webkamerának a várt módon kell működnie.",
  mediaErrorTooltip: "Kattintson ide további információkért",
  mediaErrorTitle: "A GlobalVET nem tudja használni ezt a médiaeszközt",
  mediaErrorWarningText:
    "Hiba történt a médiaeszköz beállítása során. Kérjük, próbálja meg az alábbi lépéseket a probléma megoldásához.",
  mediaErrorSuggestion1: "Zárja be azokat az alkalmazásokat, amelyek esetleg használják a kamerát",
  mediaErrorSuggestion2: "Zárja be, majd nyissa meg újra a böngészőt",
  mediaErrorSuggestion3: "Ha külső kamerát vagy mikrofont használ, válassza le, majd csatlakoztassa újra",
  mediaErrorSuggestion4: "Ellenőrizze az operációs rendszer média beállításait",
  permissionRequestTitle: "Engedély szükséges",
  permissionRequestText:
    'Ahhoz, hogy ezt a médiaeszközt használni tudja, kattintson az "Engedélyezés" vagy "Tiltás" gombra a böngésző által megjelenített engedélykérő ablakban. Ennek az ablaknak a megjelenése eltérő lehet a különböző böngészőkben.',
  permissionRequestInfo:
    'Ha nem szeretné engedélyezni a mikrofonja vagy kamerája használatát, kattintson az "Tiltás" gombra. A videókonzultációhoz ebben az esetben is tud csatlakozni.',
  voiceDetectionText: "Kattintson ide, ha engedélyezni szeretné a hangdetektálást",
  autoPlayHeader: "Automatikus hanglejátszás",
  autoPlayText: "A böngészője felhasználói interakciót kér a hanglejátszhoz. Kérjük kattintson az alábbi gombra.",
  preparingConsultation: "Felkészülés a konzultációra...",
  startConsultation: "Konzultáció elindítása",
  resumeConsultation: "Konzultáció folytatása",
  pauseConsultation: "Konzultáció szüneteltetése",
  finishConsultation: "Konzultáció befejezése",
  copyMeetingLinkCopiedToClipboard: "Konzultáció linkjének vágolapra másolása",
  meetingLinkCopiedToClipboard: "A konzultáció linkje a vágólapra lett másolva!",
  linkCopied: "Link másolva!",
  disableCamera: "Kamera kikapcsolása",
  disableMicrophone: "Mikrofon kikapcsolása",
  leaveMeeting: "Kilépés a konzultációból",
  waitingForOtherParticipants: "Még nincsenek résztvevők. Kérjük, várjon, amíg a többiek csatlakoznak...",
  inviteToMeeting: "Mások meghívása",
  joinConsultation: "Csatlakozás a konzultációhoz",
  connectingToVideoConsultationRoom: "Csatlakozás a videókonzultáció szobához...",
  areYouSureToClose: "Biztosan bezárja a beszélgetést?",
  youHaveDisconnected: "Ön kilépett a videókonzultáció szobából.",
  serverConnectionLost: "A szerverrel való kapcsolat megszakadt.",
  meetingDuration: "Időtartam: ",
  reconnectToMeeting: "Újracsatlakozás a beszélgetéshez",
  goBackToWaitingRoom: "Vissza a várószobába",
  meetingDeviceError: "Hardveres probléma",
  meetingGrantPermissions:
    "Kérem csatlakoztasson egy mikrofont, egy webkamerát, adja meg a szükséges engedélyeket, majd frissítse az oldalt.",
  reloadMeeting: "Oldal frissítése",
  addVideoConsultation: "Videókonzultáció hozzáadása",
  inPersonExamination: "Személyes vizsgálat",
  onlineVideoConsultation: "Online videókonzultáció",
  connectToVideoConsultation: "Csatlakozás a videókonzultációhoz",
  needPetOwnerEmailError: "A videókonzultációhoz a gazda email címe szükséges.",
  setPetOwnerEmailLink: "Email cím beállítása.",
  videoConsultationError: "Videókonzultáció hiba",
  payableCallTime: "Fizetendő hívásidő",
  consultationNotStartedYet: "A konzultáció még nem kezdődött el",
  consultationInProgress: "A konzultáció folyamatban van",
  consultationPaused: "A konzultáció szünetel",
  consultationFinished: "A konzultáció befejeződött",
  yearSingular: "év",
  yearPlural: "év",
  monthSingular: "hónap",
  monthPlural: "hónap",
  daySingular: "nap",
  dayPlural: "nap",
  hourSingular: "óra",
  hourPlural: "óra",
  minuteSingular: "perc",
  minutePlural: "perc",
  secondSingular: "másodperc",
  secondPlural: "másodperc",
  finishConsultationInfo:
    "Éppen egy aktív, jelenleg szüneteltetett konzultáció befejezésére készül. A konzultáció befejezése előtt lehetősége van módosítani a fizetendő hívásidőt, ami a kórlapban fog szerepelni. Alternatívaként befejezheti a konzultációt anélkül, hogy hozzáadná a kórlaphoz. Kérjük, vegye figyelembe, hogy a konzultáció befejezése minden felhasználót eltávolít a szobából, és értesíti őket erről a döntésről.",
  finalPayableCallTime: "Végleges fizetendő hívásidő",
  finalPayableAmount: "Végleges fizetendő összeg",
  continueConsultation: "Konzultáció folytatása",
  finishAndAddToMedicalRecord: "Befejezés és hozzáadás a kórlaphoz",
  justDisconnect: "Csak kilépés",
  resetToCurrentTime: "Visszaállítás az aktuális hívásidőre",
  consultationSuccessfullyFinished:
    "A videókonzultáció sikeresen lezárult, és az erre vonatkozó tétel hozzá lett adva a kórlaphoz.",
  newConsultationSession: "Új konzultáció",
  newConsultationSessionWarning:
    "Ehhez a foglaláshoz már befejeződött egy konzultáció. Szeretne új konzultációt kezdeni? Ez külön bejegyzésként fog megjelenni a kórlapban.",
  startNewConsultation: "Új konzultáció indítása",
  hiddenVideosText: "további...",
  fullScreenNotSupported: "A teljes képernyős mód nem támogatott ebben a böngészőben!",

  // Video consultation monitor
  roomId: "Szoba azonosító",
  noActiveRoomsMessage: "Jelenleg senki sem használja a videóchat szolgáltatást.",
  noInactiveRoomsMessage: "Nincs nemrégiben deaktivált szoba.",
  videoConsultationRoomMonitor: "Videókonzultáció szoba monitor",
  videoChatUser: "Videóchat felhasználó",
  latestJoinDate: "Legutóbbi csatlakozás dátuma",
  timeSinceLatestJoin: "Legutóbbi csatlakozás óta eltelt idő",
  stateOfMediaDevices: "Médiaeszközök állapota",
  latency: "Késleltetés (ping)",
  ms: "ms",
  device: "Eszköz",
  mobile: "Mobil",
  tablet: "Tablet",
  desktop: "Asztali számítógép",
  micEnabled: "A mikrofon be van kapcsolva.",
  micDisabled: "A mikrofon ki van kapcsolva.",
  camEnabled: "A kamera be van kapcsolva.",
  camDisabled: "A kamera ki van kapcsolva.",
  micWorking: "A mikrofon megfelelően működik.",
  micMissing: "A mikrofon nem található.",
  micError: "A mikrofont nem sikerült megfelelően beállítani.",
  camWorking: "A kamera megfelelően működik.",
  camMissing: "A kamera nem található.",
  camError: "A kamerát nem sikerült megfelelően beállítani.",
  roomIsBeingDeleted: "Ez a szoba hamarosan törlésre kerül...",
  consultationStatus: "Konzultáció státusz",
  waitingForStart: "Várakozás az állatorvosra, hogy elkezdje a konzultációt...",
  started: "Elkezdődött",
  paused: "Szüneteltetve",
  finished: "Befejeződött",
  waitingForVet: "Várakozás az állatorvosra...",
  waitingForPetOwner: "Várakozás a gazdára...",
  waitingForBoth: "Várakozás állatorvosra és a gazdára...",
  bothPresent: "Az állatorvos és a gazda is jelen van",
  eventSequenceNumber: "Esemény szekvenciaszáma",
  eventType: "Esemény típusa",
  eventDate: "Esemény dátuma",
  eventData: "Esemény adat",
  thereAreNoEvents: "Nincs ehhez a szobához kapcsolódó esemény",
  reservation: "Foglalás",
  liveUserInformation: "Élő felhasználói információk",
  eventHistory: "Eseménytörténet",
  goToMedicalRecord: "Ugrás a kórlapra",
  startedAt: "Kezdés időpontja",
  totalConsultationTime: "Teljes konzultációs idő",
  payableConsultationTime: "Fizetendő konzultációs idő",
  totalBreakTime: "Teljes szünetidő",
  videoConsultationFeeOfTheClinic: "A rendelő videó konzultációs díja",
  globalVetFee: "GlobalVET díj",
  currentClinicFee: "Aktuális rendelői díj",
  currentGlobalVetFee: "Aktuális GlobalVET díj",
  activeRooms: "Aktív szobák",
  inactiveRooms: "Nemrégiben deaktivált szobák",
  guest: "Vendég",
  roles: "Szerepek",
  session: "Alkalom",
  sessionHistory: "Korábbi konzultációk",
  thereAreNoPreviousSessions: "Nincs korábbi videókonzultációs alkalom",
  deleteAllRooms: "Összes szoba törlése",
  deleteAllRoomsWarning:
    "Figyelem! Az összes szoba törlése a videochat signal service-t alaphelyzetbe állítja. Ez a művelet akkor lehet hasznos, ha néhány szoba érvénytelen állapotba került.",
  addTestMeetingButtonText: "10 perc konzultáció hozzáadása",
  addTestMeetingSuccess: "Sikeresen hozzáadtál 10 perc tesztkonzultációt a kórlaphoz!",
  sendLogsToServerButtonText: "Logok küldése a szervernek",
  sendLogsToServerSuccess: "Sikeresen elküldtük a logokat a szervernek!",
  logs: "Logok",
  remoteClientLogs: "Távoli kliens logok",
  noRemoteClientLogsMessage: "Nincs távoli kliens log.",
  deleteRemoteClientLogs: "Távoli kliens logok törlése",
  deleteRemoteClientLogsWarning:
    "Figyelem! Csak akkor törölje a távoli kliens logokat, ha végzett a debugolással, mivel ez a művelet véglegesen eltávolítja az összes logot.",

  // NumberFormatter
  thousandsSeparator: "\u2009",

  willBeSentToEmail: "A kórlapból generált pdf a következő email címre lesz elküldve:",

  mute: "Némít",
  anyVet: "Bármelyik állatorvos",
  appointmentPeriodOnOverlappingFreeTimeSlots:
    "Az időpont nem megfelelő a rendelői dolgozók beosztásának. Próbálja meg szabad idősáv elején, vagy végén, vagy válasszon ki egy állatorvost!",
  changeLogo: "Logó váltás",
  uploadLogo: "Logó feltöltés",
  deleteLogo: "Logó törlés",
  unsupportedFileType: "A kép fájltípusa nem támogatott. A támogatott fájltípusok a következők:",
  changeProfilePicture: "Profilkép váltás",
  uploadProfilePicture: "Profilkép feltöltés",
  deleteProfilePicture: "Profilkép törlése",
  pictureChanged: "Sikeres képmódosítás.",
  prescriptionOnlyMode: "eRecept-mód",
  prescriptionOnlyModeTooltip:
    "Az eRecept-módban a rendelő csak recepteket állíthat ki, a rendszer többi funkcióhoz nem férhet hozzá.",
  switchToPrescriptionOnlyMode: "Váltás eRecept-módra",
  fullMode: "Teljes mód",
  switchToFullMode: "Váltás teljes módra",
  switchToPrescriptionOnlyModeWarning:
    "A klinike eRecept-módra váltásával más funkciók elérhetetlenek lesznek, mint a Raktárkezelés, Számlakezelés, Kórlapkezelés és Műszakkezelés.",
  switchToFullModeWarning:
    "A rendelő teljes módra váltásával további költségek is terhelik a klinikát, amelyek magába foglalják a klinikában dolgozó felhasználók utáni előfizetést is.",
  switch: "Váltás",
  usePrescriptionOnlyMode: "eRecept-mód használata",
  usageMode: "Használati mód",

  // Support
  helpCenter: "Súgóközpont",
  goBackTohelpCenter: "Vissza a súgóközpontba",
  guidesForGettingStarted: "Útmutatók a kezdéshez",
  topSupportTopics: "Legnépszerűbb témák",
  seeAllSupportTopics: "Összes téma megtekintése",
  supportTopics: "Témák",
  stripeIntegrationSupportContent:
    "Az online fizetések lebonyolítására a {0} keretrendszert használja a GlobalVet. A Stripe használata regisztrációhoz kötött, csomagtól függően a fizetések kezeléséért további díjakat számolhatnak fel. A Stripe integrálásához szükséges lépések:",
  stripeIntegrationSupportStep1: "Stripe fiók létrehozása",
  stripeIntegrationSupportStep2: "Stripe kulcsok másolása",
  stripeIntegrationSupportStep3: "Stripe kulcsok beillesztése",
  szamlazzIntegrationSupportContent: "Az automatikus számlázz.hu számlázás aktiválásához szükséges lépések:",
  costsOfSzamlazz: "Számla Agent költségei.",
  szamlazzIntegrationSupportStep1: "Számlázz.hu regisztráció majd belépés",
  szamlazzIntegrationSupportStep2:
    "Számla Agent kulcs másolása a számlázz.hu fiókból (vezérlőpult oldal alján: Számla Agent kulcsok rész)",
  szamlazzIntegrationSupportStep3: "Számla Agent API kulcs beillesztése",
  needToContactUs: "Kapcsolatba szeretnél lépni velünk?",
  feelFreeToCotactUs: "Bármilyen kérdés esetén vedd fel velünk a kapcsolatot a következő e-mail címen: {0}.",
  registerFirst: "Ehhez a művelethez felhasználói fiókra lesz szüksége, ha még nincs, {0}.",
  userRegistration: "Felhasználó létrehozása",
  userRegistrationContent:
    "Csak egyetlen regisztrációra van szükség, függetlenül attól, hogy Ön háziállat-tulajdonos vagy állatorvosi dolgozó. A regisztráció után bejelentkezve kiválaszthatja, hogy háziállat-tulajdonosként vagy állatorvosi dolgozóként kíván-e eljárni.",
  clinicRegistration: "Rendelő létrehozása",
  clinicRegistrationContent:
    "Menedzseljen akár több rendelőt is, mindegyik önálló cégként regisztrálható. Miután sikeresen létrehozta rendelőjét, már hívhatja is kollégáit.",
  becomePetOwner: "Gazdi lennék",
  becomePetOwnerContent:
    "Váltson gazdi módra a felhasználói menüből. Innen már csak kedvencét kell regisztrálnia és foglalhatja is első időpontját bármelyik klinikához.",
  becomeClinicEmployee: "Rendelőben dolgoznék",
  becomeClinicEmployeeContent:
    "Váltson rendelő dolgozói módra a felhasználói menüből. Alapesetben itt láthatóak a létrehozott rendelők és a meghívások. Amikor egy rendelő tulajdonosa felkéri Önt, hogy csatlakozzon a rendelőjéhez, e-mail üzenetet és értesítést is fog kapni róla.",
  slackSupportInfo: "Bármilyen hiba, kérdés, elakadás kapcsán keress minket bátran!",
  slackSupportProblemLabel: "Miben segíthetünk?",
  slackSuccess: "Megkaptuk az üzenetet, hamarosan jelentkezünk!",
  signInToContactUs: "Jelentkezz be, hogy felvehesd velünk a kapcsolatot.",
  supportNotAvailable: "Ügyfélszolgálati rendszerünk jelenleg nem elérhető. Kérjük, küldj nekünk e-mailt a {0} címre.",
  legalDocuments: "Jogi dokumentumok",
  generalLegalDocuments: "Általános",
  userLegalDocuments: "Regisztrált felhasználóknak",
  clinicLegalDocuments: "Regisztrált rendelőknek",

  supportTicketHeader: "Új hibajegy létrehozása",
  supportTicketTitle: "Cím",
  supportTicketBody: "Üzenet",
  supportTicketType: "Típus",
  supportTicketTypeChoose: "-- Válassz egy hibajegy típust --",
  supportTicketFullName: "Teljes név",
  supportTicketEmail: "Email cím",
  supportTicketPhoneNumber: "Telefonszám",
  supportTicketLanguage: "Nyelv",
  supportTicketSendButton: "Hibajegy leadása",

  supportTicketCreated:
    "Hibajegye feladásra került. Hamarosan kapni fog egy emailt benne egy linkkel az elkészített hibajegyére.",

  supportTicketChatAnswerTitle: "Új üzenet",
  supportTicketChatAnswerButton: "Küldés",

  supportTicketState: "Állapot",
  supportTicketIsClosed: (date: string): string => `Hibajegye lezárásra került ekkor: ${date}. Köszönjük megkeresését!`,

  // Support Ticket Types
  supportTicketTypeError: "Rendszer hiba",
  supportTicketTypeSupport: "Support",
  supportTicketTypeSubscription: "Előfizetés",

  // Support Ticket States
  supportTicketOpen: "Nyitott",
  supportTicketClosed: "Lezárt",
  backToTicketsPage: "Vissza a hibajegyekhez",
  myTickets: "Hibajegyek",
  closed: "Lezárt",
  createTicket: "Hibajegy létrehozása",
  subject: "Tárgy",
  supportTicketDescription: "Leírás",
  invalidTicketUrl: "Érvénytelen URL",
  ticketNotFoundOrNotAuthorized: "A hibajegy nem elérhető.",
  help: "Segíthetünk?",
  siteManagerMode: "Adminisztrátor mód",
  shiftSuccessfullyModified: "A műszakot sikeresen módosította.",
  weAreSorry: "Sajnáljuk.",

  // Feedbacks
  feedbacks: "Visszajelzések",
  survey: "Kérdőív",
  sendFeedback: "Küldés",
  feedbackAlreadySent: "Már korábban elküldte a véleményét. Köszönjük!",
  feedbackSuccess: "Köszönjük a visszajelzést!",
  feedbackQuestion: "Mit gondol a rendszerünkről?",
  feedbackAnswerPlaceholder: "Kérjük, írja le a véleményét!",
  feedbackAge: "éves",
  feedbackPets: "kisállat",

  // Clinic profile
  clinicPublicProfile: "Nyilvános adatlap",
  clinicProfileContacts: "Kapcsolat",
  clinicProfileOpeningHours: "Nyitvatartás",
  clinicProfileSpecialOpeningHours: "Egyedi nyitvatartás",
  clinicProfileSpecialOpeningHoursAddNew: "Hozzáadás",
  clinicProfileIntroduction: "Bemutatkozás",
  clinicProfileColleagues: "Csapattagok",
  clinicProfileAvailableServices: "Elérhető szolgáltatások",
  clinicProfileCustomSections: "Egyedi tartalmak",
  clinicProfileCustomSectionTitle: "Cím",
  clinicProfileCustomSectionContent: "Tartalom",
  clinicProfileCustomSectionAddNew: "Hozzáadás",
  clinicProfileVisibility: "Adatlap láthatósága",
  employeesVisibility: "Munkatársak láthatósága",
  reservationTypesVisibility: "Szolgáltatások láthatósága",
  contactsVisibility: "Elérhetőségek láthatósága",
  visibleEmployees: "Megjelenítendő munkatársak",
  clinicProfileSettingsTooltip:
    "Itt szabhatod testre a rendelő publikus adatlapját, amit az állattulajdonosok láthatnak.",
  viewClinicProfile: "Adatlap megtekintése",
  clinicWebsite: "Weboldal",
  copyLink: "Link másolása",

  // Opening hours
  clinicClosed: "zárva",
  clinicOpensAt: "nyitás",
  clinicClosesAt: "zárás",

  // Active status
  activeStatusActiveDescription: "Aktív, használatban van",
  activeStatusInactiveDescription: "Inaktív, nincs használatban",
  activeStatusActive: "Aktív",
  activeStatusInactive: "Inaktív",
};
